export default {
  routeTitle: {
    MyLv: 'My level',
    Invitation: 'Invitation rewards',
    InviteRules: 'Invitation rewards',
    InviteRank: 'Invitation Ranking',
    InviteCode: 'Invitation rewards',
    AnchorCertification: 'Host Certification',
    AuthenticatedAnchor: 'Host Certification',
    AnchorRecord: 'Live Record',
    FirstRecharge: 'First Recharge',
    GoodNumber: 'Pretty ID',
    GoodNumberRule: 'GoodNumberRule',
    SelectGoodNumber: 'SelectGoodNumber',
    AgentAccount: 'Reseller',
    Agentdetails: 'Bill',
    Agentfriend: 'Agent friend',
    WishList: 'Starlight Collection',
    WishListrank: 'Starlight Collection',
    ResidentRecharge: 'Recharge rewards',
    VIPRule: 'VIP',
    Navigation: 'The Great Navigator',
    Points: 'Diamonds',
    PointsBill: 'Bill',
    PointsExchange: 'Exchange',
    PointsExchangeDetails: 'Exchange',
    PointsWithdrawal: 'Withdraw',
    PointsWithdrawalDetails: 'Diamond withdrawal',
    PointsTransfer: 'Transfer',
    PointsTransferRecord: 'Diamond transfer records',
    JinDynasty: 'Resellers',
    OrderFeedback: 'Order feedback',
    Adjha: 'Eid al-Adha',
    AppTransferDetail: 'Transfer',
    AgencyPayroll: 'Payroll',
    RaceCar: 'Racing Car Competition',
    CpRank: 'CP Rank',
    LevelRewards: 'Level Reward',
    Permissions: 'Advanced permissions', // 外管权限
    AgencyApply: ' Agency president', // 代理申请
    Banlist: 'Ban management', // 禁言管理
    Management: 'Agency management', // 公会管理
    CpResident: 'Dreamy Couple',
    MedalRace: 'Glory Competition',
    HallOfFame: 'Miparty Hall Of Fame',
    PersonalGlory: 'Personal Glory',
    ActivityGlory: 'Activity Glory',
    AgencyAnniversary: 'Agency Anniversary',
    AgencyOwnerBirthda: 'Agent Birthday',
    Discount: '50% Off Sale',
    SwitchInstructions: 'Switch Description',
    InviteNewUsers: 'Invite friends to get rewards',
    JungleAdventure: 'Miparty Jungle Adventure',
    SevenDaysOfJoy: 'Miparty Daily Challenge',
    KingOfTheForest: 'King Of The Forest',
    Christmas2025: 'Merry Christmas',
  },
  common: {
    Lucky: 'Lucky',
    MaxL: 'Max lucky',
    CP: 'CP',
    Days: 'Days',
    Hours: 'Hours',
    Min: 'Minutes',
    Sec: 'Seconds',
    Headwear: 'Headwear',
    Badge: 'Badge',
    Ride: 'Ride',
    ExP: '2x Exp Card',
    Pinup: 'Pin up',
    VIP: 'VIP',
    Coins: 'coins',
    Rule: 'Rule',
    Day: 'Days：Hours：Minutes：Seconds',
    Act: 'Activity gifts',
    xxc: 'xx coins',
    Max: 'Max Lucky',
    Ord: 'Ordinary gifts: 10coins =8<div class="moon"></div>, lucky gifts：20 coins =1<div class="moon"></div>',
    Bob: 'Miparty reserves the right of final interpretation of this activity.This event is not affiliated with Apple.',
    Rew: 'Reward Preview',
    Rew1: 'Reward',
    Hea: 'Headwear*{x}',
    Bad: 'Badge*{x}',
    Ridex: 'Ride*{x}',
    xxc2: '{xx} coins',
    xxx: '{xxxx} diamond',
    The: 'Theme*{X}',
    The3: 'Theme Skin*{X}',
    VIPXX: 'VIP{X}*{XX}',
    Con: 'Congratulations',
    Con4: 'Congratulations! You have received the following rewards!',
    Rec: 'Receive',
    Rec5: 'Received',
    Ran: 'Ranking Reward',
    TopX: 'Top{X}',
    more: 'more',
    Back: 'Back',
    Rec6: 'Record',
    Date: 'Date',
    Rank: 'Rank',
    Wea: 'Wealth',
    Charm: 'Charm',
    Ord2: 'Ordinary gifts: 10coins =8 diamond, lucky gifts：20coins =1 diamond',
    Call: 'Call voucher',
    Hea2: 'Headwear',
    Bad2: 'Badge',
    Ridex2: 'Ride',
    xxc22: 'coins',
    xxx2: 'diamond',
    The2: 'Theme',
    Receive: 'Receive',
    Received: 'Received',
    Finished: 'Finished',
    SignedIn: 'Signed in',
    Mlu: 'M-Lucky',
    Luc: 'Lucky',
    This: 'This event has ended',
    time: '{0} time',
    times: '{0} times',
    Oicon: 'General gifts: 1coins =1 {var1}, lucky gifts：10 coins =1 {var2}',
  },

  myLv: {
    Wea: 'Wealth',
    Charm: 'Charm',
    lvDescr: 'level description',
    Upgrade: 'Upgrade level still need to',
    tips1: 'When you send 1 coin, you gain 1 experience (sending a lucky gift will only gain 10% experience). As the level increases, the icon style will also change.',
    tips2: 'When you receive 1 diamond, you gain 1 experience. As the level increases, the icon style will also change.',
    tips3: 'When you input 1 coin to play game, you gain 1 experience. As the level increases, the icon style will also change.',
    Game: 'Game',
  },
  invitation: {
    How: '1.How to invite：',
    Sha: '(1)Share the link to invite your friends to register, if your friends are downloading the application for the first time, they will be automatically invited to succeed after the registration is completed;',
    Reg: '(2) Register within three days, fill in your invitation code.',
    How1: '2.How to earn rewards：',
    Ift: 'If the invited person becomes the host and completes the following tasks, you will get the corresponding rewards.',
    Tasks: 'Tasks',
    settlement: '3. Reward settlement time：',
    settlement2: 'Settlement will be carried out at 0:00 the next day (GTM+7)',
    How2: '4.How to become a host：',
    Tal: '(1)Talent host:',
    Ste: 'Step1: Open the stream live and pass the face verification.',
    Ste3: 'Step2: Contact the official for review to become a talent host.',
    Non: '(2) Non-talent host: as long as you not a talent host.',
    Oth: '4、Other rules',
    Fil: '(1) Fill in invitation code within three days after registration, if not, the invitation will fail.',
    Ify: "(2) If you have bound with other users, you can't bind again.",
    New: '(3) New host (registered less than 7 days) daily statistics only 3 hours of live time.',
    Ify4: 'If you are invited by invitation code, you need to fill in the invitation code within 3 days after registration, otherwise the invitation will fail.',
    Non5: 'Non-talent host',
    Use: 'User task',
    Use6: 'User ID',
    Nic: 'Nickname',
    Hos: 'Host task',
    Rule: 'Rule',
    You: 'Your invitation code is',
    Inv: 'Invite now',
    Fil7: 'Fill in invitation code',
    Myr: 'My reward',
    Bin: 'Binding failed',
    Ok: 'Ok',
    Can: 'Cancel',
    Inv8: 'Invite new user',
    Bin9: 'Bind successfully',
    Cop: 'Copy invitation code',
    Dow: 'Download',
    Inv10: 'Invite friends to play',
    Max: 'Maximun get %s diamond',
    Poi: 'Diamond Received',
    Coi: 'Coins Received',
    Num: 'Number of Invitees',
    Poi11: 'Diamond earned',
    Coi12: 'Coins earned',
    Poi13: 'Diamond to be received',
    Coi14: 'Coins to be received',
    Rec: 'Receive',
    Use15: 'User ID',
    Nic16: 'Nickname',
    Hos17: 'Host type',
    Tal18: 'Talent host',
    Non19: 'Non-talent host',
    Age: 'Agency Code',
    Hos20: 'Host live time in 7 days',
    Hos21: 'Host gift diamond in 30 days',
    Rec22: 'Recharged coins in 60 days',
    Tot: 'Total diamond reward',
    Tot23: 'Total coins reward',
    Reward: 'Reward Point',
    Confirm: 'Confirm',
    exclusive: 'Your exclusive invitation code',
    Ple: 'Please click the confirm button',
    Invv: 'Invite friends to play and get more rewards~',
    Con: 'Configuration does not exist',
    Coin: 'Coin agent cannot transfer diamond to other coins agent',
    Cann: 'Cannot transfer the same user twice within one minute',
    IDt: '{0} (ID: {1}) transferred {2} diamond to you. Please check your diamond~',
    Inv1: 'Invited host, audio room/call/video income within 30 days reaches {xx} diamond (excluding platform rewards)',
    Inv2: 'Invited users, recharge {xx} dollar on Google/payermax within 60 days',
    For: '*For new users who are invited by invitation code, they must fill in the invitation code within 7 days of registration, otherwise the invitation will fail.',
    Rank: 'Rank',
    Cops: 'Copy invitation code successfully',
    Cop3: 'Copy invitation link successfully',
    Rect: 'Receive time',
    Rew: 'Reward coins',
    Usea: 'User Avatar',
    Tas: 'Task type',
    Com: 'Come#Miparty#and join our game agency to interact,come on interact with us',
    Copy: 'Copy',
    Ple4: 'Please write the invitation code',
    Sel: 'Selected',
    Ple5: 'Please select the diamond level',
    Ple6: 'Please confirm the coin agent of the transfer',
    The: 'The maximum %s of coins can get',
    Coi7: 'Coin agent diamond exchange for coins',
    Tra: 'Transfer Successful',
    Fix: 'Fix bugs',
    Poib: 'Diamond bill',
    The8: 'The total:%s',
    Poi9: 'Point transfer record',
    Coi10: 'Coin agent exchage for conis',
    Tod: 'Today diamond transfer exceeds limit',
    Tra11: 'Transfer ID: %1$s',
    invites: '{XXX}(ID:{sss})invites you to join Miparty, come and play with us!',
  },
  invitation2: {
    Inv: 'Invite',
    Rules: 'Rules',
    Ran: 'Ranking',
    You: 'Your invitation code',
    Inv1: 'Invite now',
    Ent: 'Enter invitation code',
    Myr: 'My reward',
    Coi: 'Coins received',
    Inv2: 'Invited number',
    Coi3: 'Coins to be collected',
    Coi4: 'Coins unsettled',
    Use: 'User ID',
    Use5: 'User nickname',
    Hos: 'Host type',
    Age: 'Agency ID',
    Bin: 'Binding time',
    Gam: 'Game input',
    Tot: 'Total reward coins',
    Rul_1: 'Rules\n1. How to invite:\n',
    Rul_2:
      '(1) Share the link to invite friends to register. If your friends are downloading the app for the first time, the invitation will be automatically completed after their registration.',
    Rul_3: '(2) Need to use the invitation code within 7 days of registration.',
    Rul_4: '2. How to earn rewards:',
    Rul_5: "If the invited user plays the game in your room after binding, you will receive 0.1% of the user's game input as a reward.",
    Rul_6: '*Note: If the invited user plays the game in other rooms, you cannot get his game sharing. Please remind your friends to play in your room.',
    Rul_7: '3. Other rules',
    Rul_8: '(1) Invited user must to use your invitation code within 7 days of registration. If it exceeds 7 days, the invitation will fail.',
    Rul_9: '(2) If you have bound to another user, you cannot bind again.',
    Inv6: 'Invitation Ranking',
    Con: 'Congratulations to [nickname] for getting xxx coin reward',
    Rules7: 'Rules',
    For: '*For invitations through invitation codes, new users must use the invitation code within 7 days of registration, otherwise the invitation will fail',
    Bin8: 'Binding failed',
    You9: 'You have bound <span class="yellow">{0} (ID: {1})</span> and cannot bind again',
    Sor: 'Sorry, you have registered for more than 7 days and cannot bind',
    Con10: 'Congratulations, you have bound with <span class="yellow">{0} (ID: {1})</span>',
    XXI: '{XX} (ID: xxx) invites you to join Miparty, come and play together~',
    Cop: 'Copy invitation code',
    Dow: 'Download',
    Coi11: 'Coins collected',
    Use12: 'User ID',
    Use13: 'User avatar',
    Use14: 'User nickname',
    Rew: 'Reward coins',
    Col: 'Collection time',
    Inv15: 'Invited number',
    Hos16: 'Host type',
    Age17: 'Agency ID',
    Bin18: 'Binding time',
    Gam19: 'Game input',
    Date: 'Date',
    Gam20: 'Game input',
    Rew21: 'Reward coins',
    Sta: 'Status',
    Col22: 'Collection time',
    Reward: 'Reward',
    Voice: 'Voice',
    Video: 'Video',
    Not: 'Not claimed',
    claimed: 'claimed',
    Official: 'Official deletion',
    freeze: 'Official freeze',
    Unsettled: 'Unsettled',
    InvitationCode: 'Invitation code',
    pleasEnterCode: 'pleas enter code',
  },
  anchorCertification: {
    Hos: 'Host Certification',
    Not: '*Note: Each user can only join one agency',
    Hot: 'Hot Recommendations',
    Sea: 'Search',
    App: 'Apply',
    Age: 'Anency ID',
    Age1: 'Agency Name',
    Reg: 'Region',
    Age2: 'Agency ranking',
    Myr: 'My ranking',
    Und: 'Under review',
    You: 'You already had an agency',
    Res: 'Result of applying',
    Ple: 'Enter the Agency Name or ID',
    Nom: 'No more agencies',
    Liv: 'Live Record',
    Hos3: 'Host type',
    Voi: 'Voice host',
    Vid: 'Video host',
    Thi: 'This week income',
    Thi4: 'This month income',
    Thi5: 'This month live time',
    Thi6: 'This month active days',
    Thi7: 'This month ranking',
    Tot: 'Total income',
    Tot8: 'Total live time',
    Date: 'Date',
    Gif: 'Gifts income',
    Oth: 'Other income',
    Sol: 'Solo live time',
    Mul: 'Multiple live time',
    Voi9: 'Voice live time',
    Eff: 'Effective days',
    Mya: 'My agency',
    Age10: 'Agency type',
    Voice: 'Voice',
    Video: 'Video',
    Thi11: 'This month total income',
    Las: 'Last month total income',
    Mem: 'Member number',
    Thi12: 'This month ranking',
    Age13: 'Agent certification',
    Fai: 'Failed',
    Ver: 'Verified',
    Pen: 'Pending',
    Ver14: 'Verifying',
    Hos15: 'Host info',
    Inc: 'Income',
    Sol16: 'Solo live time',
    Mul17: 'Multiple live time',
    Voi18: 'Voice live time',
    Eff19: 'Effective days',
    Mem20: 'Member management',
    Exi: 'Existing',
    Inv: 'Invitation',
    App21: 'Application',
    Mem22: 'Members',
    Rem: 'Remove',
    Con: 'Confirm to remove [Nickname](id：xxx)?',
    Aft: '*After removal, all his data will be removed from the agency and cannot be retrieved. Please be careful!',
    Can: 'Cancel',
    Con23: 'Confirm',
    Inv24: 'Invite',
    Agree: 'Agree',
    Rej: 'Reject',
    Fans: 'Fans',
    Apply: 'Apply',
    Inv25: 'Invite again',
    Inv26: 'Invited',
    Dis: 'Disagree',
    Hos27: 'Host ranking',
    Daily: 'Daily',
    Wee: 'Weekly',
    Mon: 'Monthly',
    Pre: 'President Nickname',
    Pre1: 'President ID',
    Nic: 'Nickname',
    Nom2: 'No more',
    Joi: 'Joined time',
    Pre2: 'President',
    Alr: 'Already joined other agency',
    Joi3: 'Joined',
    Off: 'Official rejection',
    Off4: 'Official approval',
  },
  firstRecharge: {
    Fir: 'First Recharge benefits',
    Asi: 'A single online recharge reaches the specified amount, you can get the benefits',
    Extra: 'Extra +{0}',
    coi: '40coins gift*{0}',
    Ride: 'Ride*{0}',
    Hea: 'Headwear*{0}',
    Cry: 'Crystals*{0}',
    Got: 'Go to Recharge',
    Not: '1. The First Recharge benefits are only for new users who recharge for the first time.\n\n2. After the recharge is successful, the event reward will be automatically sent.\n\n3.Recharge $0.99, $9.99, $49.99, $99.99to get corresponding rewards.\n\n4. The ownership of the event belongs to Miparty.\n\n5. This activity has nothing to do with Apple.',
    Che: 'Check details>>',
    Fir1: 'First rechage\nTo get rich rewards',
    Con: 'Congratulations on {0} getting ${1} Recharge benefits!',
    Fir2: 'First Single \nRecharge benefits',
    Mon: 'Monthly welfare',
    Mon3: '*Monthly Recharge any amount for the first time to get a package',
    Mon4: 'Monthly \nFirst Recharge Challenge',
    Tod: "Today's recharge time limited",
    The: '*Within the first recharge day of the month, the cumulative recharge reaches the specified amount can get rich rewards',
    Myd: 'My daily recharge',
    Pre: 'Pretty ID',
    Rec: 'Record',
    Wil: 'Will be awarded：',
    Rec5: 'Recharge',
    Kco: '1.5K coins',
    Fir6: 'First single day recharge： <span style="color:#0a611b">{0}/{1} USD</span>',
    Badge: 'Badge*{0}',
    Got7: 'Got',
    Con8: 'Congratulations on {0} upgraded to Lv.{1} !',
    Cur: 'Current month \nDaily recharge Record \n',
    Awa: 'Awarded：',
    Nor: 'No rewards.\nTry again next month!',
    Nor9: 'No rewards.\nRechrage to get rich rewards!',
    Rew: 'Rewards History',
    You: "You haven't received any recharge rewards,recharge now!",
    Rec10: 'Recharge rewards',
    None: 'None',
    Jan: 'January',
    Feb: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
    The11: 'The first recharge is successful! Click on the details to view your monthly first recharge rewards!',
    Act: 'Activity details',
    Con12: 'Confirm',
    Rules: 'Rules',
    Par: '1.Participation in this event is limited to in-app recharge and link recharge, not including agent recharge.\n2. After the event is launched, each user can participate once a month.\n3. The recharge rewards on the first day will be settled and distributed at 00:00:00(GMT+3) on the second day, only the highest level awards are given out, please pay attention to check.\n4.Recharge agent account cannot participate in this activity.\n5.The reward of Pretty ID need you to contact customer service;\n6. Miparty has the final right to interpret the activity.\n7.This event is not affiliated with Apple\n\n',
    con: 'congratulations! The Monthly welfare package for the first recharge has been issued to your backpack, please pay attention to check it! Click on the event to view the details to get more rewards!',
    con13:
      'congratulations! Completed the activity task of accumulatively recharging for the first time in a single day, and the reward has been issued to your account, please pay attention to check!',
    con14:
      'congratulations! You have recharged {1} successfully! The First Single Recharge benefits has been issued to your backpack, please pay attention to check it! Click on the event to view the details to get more rewards!',
    Con15: 'Congratulations, you have ranked top{0} last week, and rewards have been sent to you: {1} coins package gift and {VIP7}*7 ,please check it~ \n\n',
    Con16: 'Congratulations, you have ranked top{0} last month, and rewards have been sent to you:{座驾名}*30 ,please check it~ \n\n',
    Con17: 'Congratulations, you have ranked top{0} last week, and rewards have been sent to you: {1} coins package gift ,please check it~ \n\n',
    Con18: 'Congratulations, you have ranked top{0} last month, and rewards have been sent to you: {勋章名}*30 ,please check it~ \n\n',
    Con19: 'Congratulations, you have ranked top{0} last week, and rewards have been sent to you: {1} coins and {2}*7 ,please check it~',
    VIP: 'VIP{0}*{1}',
    Clevel: 'Current Level',
    Hof: 'Hall of Fame',
    IntoHof: 'The Top1 monthly first charge will be inducted into the Hall of Fame',
    MonTop1: 'Monthly Top1',
    Jan1: 'Jan.',
    Feb1: 'Feb.',
    Mar1: 'Mar.',
    Apr1: 'Apr.',
    May1: 'May',
    Jun1: 'Jun.',
    Jul1: 'Jul.',
    Aug1: 'Aug.',
    Sep1: 'Sep.',
    Oct1: 'Oct.',
    Nov1: 'Nov.',
    Dec1: 'Dec.',
    Current4: 'Current Month Record',
  },
  goodNumber: {
    free: 'Free to get your personal  pretty ID',
    level: 'Your current level is: Lv. {Level}',
    level1: 'you can choose ID in the following format',
    luckyNum: 'Please choose your lucky number (Sort by number)',
    next: 'Next',
    rule: 'Rules',
    sysgen: 'The system generated the following ID for you',
    used: 'Used',
    up: 'Last page',
    down: 'Next page',
    confirm: 'Are you sure you want to choose “{Num}" as your new ID?',
    resetNum: 'Reselect lucky number',
    submitTime: 'Submit ({Time} times)',
    success: 'Successfully selected a new ID',
    inputWant: 'Enter the ID you want',
    none: 'Sorry the ID you searched for has already been used or does not match the rule',
    numToast: 'Need to choose 2 or 3 lucky numbers',
    rule1: '1.Users can upgrade their level to get the unique ID for free.',
    rule3: '2.Users who have reached the level must follow the rules in the form.',
    rule4: '3. Get unique ID, please follow the rules of the form, for example ABCAA: 12311.',
    rule6: '4. The 10000-10999 number is officially owned by Miparty.',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
  },
  agentAccount: {
    // 金代充值
    Det: 'Bill',
    Coi: 'Remaining Coins',
    Tra: 'Transfer to',
    Sea: 'Search',
    Tra1: 'Transfer coins',
    Use: 'User ID',
    Ple: 'Please enter coins amount',
    Fans: 'Fans',
    Fri: 'Friend',
    Sea2: 'Search by ID or Nick',
    Sel: 'Select',
    The: 'No more',
    Exp: 'Expenditure',
    Inc: 'Income',
    exp: 'expenditure',
    inc: 'Income',
    Use3: 'User confirmation',
    Con: 'Confirm',
    Can: 'Cancel',
    Con4: 'Confirm whether transfer',
    Ple5: 'Please inter integer',
    onf: 'Confirmed',
    onf1: 'Confirm',
    Cancel: 'Cancel',
    Freeze: 'Freeze',
    Canceled: 'Canceled',
    Frozen: 'Frozen',
    Returned: 'Returned',
    Rejected: 'Rejected',
    Completed: 'Completed',
    OfficialReward: 'Official reward',
  },
  wishList: {
    XXX: "{XXXX}'S Collection",
    Ach: 'Achievement Medal',
    Cou: 'Countdown：',
    D: 'D',
    H: 'H',
    M: 'M',
    Hav: 'Have light',
    Hal: 'Hall of Fame & Rank',
    Wee: 'Weekly starlight gifts',
    Set: 'Set1',
    Set1: 'Set2',
    Set2: 'Set3',
    Set3: 'Set4',
    Rew: 'Rewards',
    Lig: 'Light up this gift set The following rewards will be automatically sent to your account！',
    Wis: 'Starlight contributor',
    Des: 'Description',
    the: '1.the anchor collection in a total of 4 sets of gifts, each set of 5, each set of gifts have a starlight gift, as the first. Light data is updated weekly.\n',
    the2: '2. Each set of gift that the anchor lights up can get a corresponding set of rewards, and the rewards are automatically released to the account.\n',
    the3: '3. the user can send gifts to the anchor, the number of gifts to meet the corresponding requirements will light the gift.',
    the4: '4. the user can choose a key title, send a higher number than the current top to name the gift. Naming is available or exclusive privilege, please click on the gift list for details.',
    the5: '5. "Hall of Fame & List & Achievement Medal" there are more games and rewards, go to participate!',
    Hav4: 'Have light(xxx/x)',
    Giv: 'Give gifts',
    xxx: 'coins',
    Nam: 'Named privilege preview',
    Gif: 'Gift banner',
    Gif5: 'Gift panel',
    Nam6: 'Name the gift',
    Not: 'Not light up ',
    Giv7: 'Give gifts',
    xxx8: '{xxx}coins',
    Nam9: 'Named privilege preview',
    Lig10: 'Light the gift',
    The: 'This gift has not been given out yet. Come and help the host complete the collection!',
    Back: 'Back',
    Ach11: 'Achievement Medal Challenge',
    XXX12: "{XXX}'S Achievement Medal",
    Wis13: 'Star',
    Fas: 'Fastest Lighting Medal',
    Fas1: 'Fastest Lighting',
    Glo: 'Glory Mileage Medal',
    Glo1: 'Glory Mileage',
    Lig14: 'Lighting Star Medal',
    Lig141: 'Lighting Star',
    Wis15: 'Starlight Hunter',
    Wis16: 'Starlight Hunter Medal',
    Wis161: 'Wish Granter',
    Nam17: 'Named Bronze Medal',
    Nam171: 'Named Bronze',
    Nam172: 'Bronze Medal',
    Nam18: 'Named Silver Medal',
    Nam181: 'Named Silver',
    Nam182: 'Silver Medal',
    Nam19: 'Named Gold Medal',
    Nam191: 'Named Gold',
    Nam192: 'Gold Medal',
    Nam20: 'Named King Medal',
    Nam201: 'Named King',
    Nam202: 'King Medal',
    Fas21: 'Fastest lighting challenge',
    Anc: 'Anchors light up all gift challenges within <span style="color: #47FFEC">4</span> days, and get the fastest lighting medal if the challenge is successful',
    Glo22: 'Glory mileage challenge',
    All: 'All four sets of gifts are lit, and the anchor can receive the glory mileage medal',
    Lig23: 'Lighting star challenge',
    Ift: 'If the number of accumulated lighting gifts reaches <span style="color: #47FFEC">XXX</span>, the anchor can get the Lighting Star Medal',
    Wis24: 'Wish granter challenge',
    Use: 'Users can get the starlight hunter medal if the cumulative number of lighting gifts reaches <span style="color: #47FFEC">XXX</span>',
    Nam25: 'Named bronze challenge',
    The26: 'The user can get the bronze medal by naming any gift for <span style="color: #47FFEC">XXX</span> times',
    Nam27: 'Named silver challenge',
    The28: 'The user can get the silver medal by naming any gift for <span style="color: #47FFEC">XXX</span> times',
    Nam29: 'Named gold challenge',
    The30: 'The user can get the gold medal by naming any gift for <span style="color: #47FFEC">XXX</span> times',
    Nam31: 'Named king challenge',
    The32: 'The user can get the king medal by naming any gift for <span style="color: #47FFEC">XXX</span> times',
    Des33: 'Description',
    The34: '1. There are 8 MEDALS in the Achievement Medal challenge, you can click on the medal to see the challenge details.\n',
    The341: '2. Complete the challenge to obtain the medal.\n',
    The342: '3. Each challenge medal can only be awarded once per week; The challenge data is updated weekly, and the record of MEDALS won is kept on display.\n',
    The343:
      '4. If the user is suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification.\n',
    The344: '5. Miparty Live reserves the right of final interpretation of this event. This event has nothing to do with Apple.',
    Ful: 'Light up Starlight',
    Sur: 'Sure you want to send',
    XXX35: 'XXX coins',
    Con: 'Confirm',
    Rec: 'Recharge',
    You: "You don't have enough gold coins, please recharge now!",
    Wis36: 'Starlight Collection',
    days: 'Day',
    hours: 'Hour',
    minutes: 'Minute',
    seconds: 'Second',
    Sel: 'Starlight gifts Rank',
    Sea: 'Seasonal Hall of Fame',
    Ach37: 'Achievement Medal',
    Wis38: 'Star',
    Wis39: 'Starlight Hunter',
    Sel40: 'Selected Hall of Fame',
    Rew41: 'Reward',
    more: 'more',
    Top: "Top 3 of last week's Starlight gifts rank",
    Top42: 'Top 3 of Week 5 Starlight gifts rank',
    Top424: 'Top 3 of Week 4 Starlight gifts rank',
    Top423: 'Top 3 of Week 3 Starlight gifts rank',
    Top422: 'Top 3 of Week 2 Starlight gifts rank',
    Top421: 'Top 3 of Week 1 Starlight gifts rank',
    TopX: 'Top ',
    '': '',
    Las: 'Last 3 Month TOP3',
    The43: 'The user who has appeared in the Starlight Hall of Fame the most times in three months.',
    Sea44: 'Seasonal Hall of Fame Reward',
    The45: "The season Hall of Fame is waiting for you! Go light up the anchor's gift!",
    The46: "The medal of achievement I've received",
    Com: 'Complete the following challenges to earn the following MEDALS, which will be displayed on your live starlight collection',
    Rules: 'Rules',
    Eac: '1.Each set has a starlight gift, each starlight gift has its own list,There are corresponding rewards in the list\n',
    Eac2: '2. The gift data is updated at 00:00 every Monday, and the list gifts will be automatically sent to your account.\n',
    Eac3: '3. The top 3 of each starlight gift list will earn a chance to be inducted into the Hall of Fame, updated every Monday at 0:00.\n',
    Eac4: '4.The Hall of Fame list is counted once every three months, and the accumulated number of starlight halls of Fame (regardless of ranking) is at the forefront.\n',
    Eac5: '5.The Hall of Fame List Rewards are updated every 3 months, and list gifts are automatically sent to your account.\n',
    Eac6: '6. If the user is suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification.\n',
    Eac7: '7. Miparty Live reserves the right of final interpretation of this event. This event has nothing to do with Apple',
    Con47: 'Congratulations on the Light Up Set {X}~ ，Set gift reward has been released!',
    Con48: 'Congratulations!You ranked NO.A in the {榜单名字} of the "Starlight Collection" activity, and the reward has been sent!',
    Wis49: 'Star starlight gifts Rank',
    Wis50: 'Starlight Hunter starlight gifts Rank',
    Con51: 'Congratulations!You ranked NO.Z in the {榜单名字} of the "Starlight Collection" activity, and the reward has been sent!',
    Wis52: 'Star Seasonal Hall of Fame',
    Wis53: 'Starlight Hunter Seasonal Hall of Fame',
    Con54: 'Congratulations！You successfully light up {MEDAL NAME} in the "Starlight Collection" activity!',
    Con55: 'Congratulations on earning {xxx} coins in the Starlight Collection activity!',
    Con56: 'Congratulations on getting VIP{X}*Y days at the Starlight Collection activity!',
    badge: 'Badge',
    coin: 'coins',
    award1: 'Headwear',
    award4: 'Ride',
    gift: 'Gift',
    click: 'click to see more',
    Starl: 'Starlight gifts Rank',
    Star: 'Star',
    Starl1: 'Starlight Hunter',
    diamond: 'Diamond',
    Starl2: 'Starlight Hall of Fame',
  },
  residentRecharge: {
    Bob: 'Miparty\nRecharge rewards',
    Dai: 'Daily reward',
    Wee: 'Weekly reward',
    Mon: 'Monthly reward',
    Hal: 'Hall of Fame',
    Ran: 'Rank reward',
    Rec: 'Recharge accumulated:{X}/{XX} coins',
    Rul: '\n1. During the activity period, if the daily accumulated recharge reaches the above recharge limit, you will get the highest level of reward that has been reached.\n',
    Rul2: '2. The official statistical period is 00:00:00 to 23:59:59 (GMT+3) every day.',
    Rul3: '3.The rewards will be issued 24 hours after the settlement of the statistical cycle',
    k: '50k',
    k4: '150k',
    k5: '300k',
    k6: '700k',
    xxx: '<span class="moon">{xxx}</span> k more can get the next level of reward',
    Dai7: "Daily rank the top1 with highest recharge can win the next day's Display at the top of the activity page.",
    Hea: 'Headwear*xx',
    Rid: 'Ride*xx',
    Bad: 'Badge*xx',
    Dai8: 'Daily recharge',
    Wee9: 'Weekly recharge',
    Mon10: 'Monthly recharge',
    Rec11: 'Recharge now',
    Myr: 'My recharge:{xxx}k',
    xxx12: 'k more can get the next level of reward',
    k13: '1500k',
    k14: '3000k',
    k15: '5000k',
    k16: '10000k',
    k17: '20000k',
    Wee18: 'Weekly cumulative：1/1500K coins',
    Wee181: 'Weekly cumulative：',
    Wee19: 'Weekly cumulative：1/3000K coins',
    Wee20: 'Weekly cumulative：1/5000K coins',
    Wee21: 'Weekly cumulative：1/10000K coins',
    Wee22: 'Weekly cumulative：1/20000K coins',
    xxx23: 'coins',
    Rul241:
      '1. During the activity period, if the weekly accumulative recharge reaches the above recharge limit, you will get the highest level reward that has been reached at present.',
    Rul242: '2. The official statistical period is 00:00:00 on Sunday to 23:59:59 on Saturday (GMT+3);',
    // Rul243: '3. The reward of customized headwear requires you to contact customer service;\n4. If eligible, the bonus will be issued on the following Monday.',
    Rul244: '3. If eligible, the bonus will be issued on the following Monday.',
    Days: 'Days',
    Hours: 'Hours',
    Min: 'Minutes',
    Sec: 'Seconds',
    Rul251:
      '1. During the activity period, the monthly accumulated recharge reaches the above recharge limit, and the highest level of reward has been reached at present;\n',
    Rul252: '2. The official statistical period is from 00:00:00 on the first day of each month to 23:59:59 on the last day (GMT+3).',
    Rul253: '3. The reward of beautiful ID requires you to contact customer service;\n',
    Rul254: '4. If eligible, the bonus will be paid on the 1st of the following month.',
    K: '35000K',
    K26: '50000K',
    K27: '80000K',
    K28: '150000K',
    K29: '300000K',
    Mon30: 'Monthly cumulative：1/35000K coins',
    Mon301: 'Monthly cumulative:',
    Mon31: 'Monthly cumulative：1/50000K coins',
    Mon32: 'Monthly cumulative：1/80000K coins',
    Mon33: 'Monthly cumulative：1/150000K coins',
    Mon34: 'Monthly cumulative：1/300000K coins',
    Mon35: 'Monthly Recharge',
    Wee36: 'Weekly Rank reward',
    Mon37: 'Monthly Rank reward',
    DailyRank: 'Daily Rank reward',
    TOP: '1、TOP1-TOP3，banner display for a week',
    Ran38: '2、Ranking reward',
    ope: 'opening the screen advertisement*2 days',
    days: '10days',
    Las: 'Last three weeks Top3',
    TOP39: '1、TOP1 banner display for a 1 month',
    Hal40: 'Hall of Fame',
    Bob41: 'Miparty Recharge Monthly rank TOP1',
    Las42: 'Last months Top1',
    Bob43: 'Miparty Recharge Weekly rank TOP3',
    Eve: 'Event ends in：',
    Dai6: 'Daily recharge：',
    Wee1: 'Weekly recharge：',
    Mon1: 'Monthly recharge：',
    Hea2: 'Headwear*',
    Ride: 'Ride*',
    Badge: 'Badge*',
    moe: 'coins',
    Rew: 'Rewards',
  },
  VIPRule: {
    VIPRule_0: 'VIP Center',
    VIPRule_1: 'Identification',
    VIPRule_2: 'Exclusive privilege',
    VIPRule_3: 'VIP Pets',
    VIPRule_4: 'You will have different VIP Pets when you are on different VIP level.',
    VIPRule_5: 'Nickname Magnified',
    VIPRule_6: 'Your nickname will show in different colors when you are on different VIP level.',
    VIPRule_7: 'Exclusive Headwear',
    VIPRule_8:
      'You will have different exclusive headwear when you are on different VIP level. Headwear will be displayed in the personal information card, rank list, etc.',
    VIPRule_9: 'Entrance Effect',
    VIPRule_10: 'Each VIP level has a different Entrance Effect. Go into the live room with a entrance effect, show off your VIP.',
    VIPRule_11: 'Mic Sound Wave',
    VIPRule_12: 'Different mic sound wave will show when you are on different VIP level. It will be showed around your mic DP when you speak.',
    VIPRule_13: 'Exclusive Bubble',
    VIPRule_14: 'You will have different exclusive speech bubble when you are on different VIP level. It will be showed when you speak on public area.',
    VIPRule_15: 'Room Display Cards',
    VIPRule_16: 'You will have different Room display card when you are on different VIP level.',
    VIPRule_17: 'VIP Gift',
    VIPRule_18: 'You will have different VIP Gift when you are on different VIP level.',
    VIPRule_19: 'VIP Seat',
    VIPRule_20: 'You will have different VIP seat when you are on different VIP level.',
    VIPRule_21: 'Badge Slots Added',
    VIPRule_22: 'When you are VIP, you can wear more badges at the same time.',
    VIPRule_23: 'Anti Kick',
    VIPRule_24: 'If you become VIP6 or above, the host will not be able to kick you out of the room, and you can move around freely in the room.,',
    VIPRule_25: 'Anti Mute',
    VIPRule_26: 'Want to talk freely in the live room? Become VIP6 or above can have the anti mute power.,',
    VIPRule_27: 'ID column',
    VIPRule_28:
      'When you become VIP5 or above, you can have exclusive ID column. The ID colunm will be displayed in the room personal page, room personal card, personal center, etc.,',
    VIPRule_29: 'VIP Package',
    VIPRule_30: 'You can draw a lucky gift bag every day, which may contain a car, headdress or medal.',
    VIPRule_31: 'Personal Page Background',
    VIPRule_32: 'If you become VIP8 or above, the exclusive background will be displayed when entering your personal page.,',
    VIPRule_33: '{0}Coins / 30 Days',
    VIPRule_34: 'Become VIP',
    VIPRule_35: 'VIP is activated',
    VIPRule_36: '{0} days remaining',
    VIPRule_37: 'Are you sure to consume {0} coins to become {1} ?',
    VIPRule_38: 'Cancel',
    VIPRule_39: 'Confirm',
    VIPRule_40: 'Purchase succeeded',
    VIPRule_41: 'Not enough coins, please rechage',
    VIPRule_42: 'You already have higher VIP',
    VIPRule_43: '{0} Coins / Month',
    VIPRule_44: 'Identification',
    VIPRule_45: 'Exclusive priviledge',
    VIPRule_46: 'VIP is activated {0} days remaining',
    VIPRule_47: 'Not activated yet',
    VIPRule_48: 'VIP Pets',
    VIPRule_49: 'Nickname Magnified',
    VIPRule_50: 'Exclusive Headwear',
    VIPRule_51: 'Enterance Effect',
    VIPRule_52: 'Mic sound wave',
    VIPRule_53: 'Exclusive Bubble',
    VIPRule_54: 'Room Display Card',
    VIPRule_55: 'VIP Gift',
    VIPRule_56: 'VIP Seat',
    VIPRule_57: 'Badge Slots Added',
    VIPRule_58: 'Anti Kick',
    VIPRule_59: 'Anti Mute',
    VIPRule_60: 'ID column',
    VIPRule_61: 'Personal Page Background',
    VIPRule_62: '{X}*{XX}',
    VIPRule_63: 'ok',
    VIPRule_64: 'Congratulations on receiving',
  },
  // 海上航行翻译
  navigation: {
    The: 'The Great Navigator',
    Eve: 'Event time: May 26 - June 2 GMT+3',
    Thi: 'This navigation is mainly to visit three seas near the Middle East region, starting from the shore, through the Arabian Sea to the Red Sea, and then to the Persian Gulf, in the process can use diamond to deep-sea fishing, drawing prize pool rewards. Send activity gifts, earn navigation diamond, and start sailing!',
    Days: 'Days',
    Hours: 'Hours',
    Min: 'Minutes',
    Sec: 'Seconds',
    Giv: 'Give Activity Gifts',
    Rules: 'Rules',
    xxc: 'coins',
    Ord: 'General gifts: 1coin =1diamond, lucky gifts:1coin =0.1diamond.',
    The1: 'The following are the great rewards of navigation, send the activity gifts to the sea, you can collect!',
    Nav: 'Navigation',
    Dee: 'Deep-sea fishing',
    Rank: 'Rank',
    Per: 'Persian Gulf Hall of Fame',
    Per2: 'Persian Gulf',
    Red: 'Red Sea Hall of Fame',
    Red3: 'Red Sea',
    Ara: 'Arabian Sea Hall of Fame',
    Ara4: 'Arabian Sea',
    Rew: 'Rewards',
    Hea: 'Headwear',
    Rid: 'Ride',
    Bad: 'Badge',
    Theme: 'Theme',
    Tim1: 'Time\n05.26-06.02\n',
    Tim2: 'Rules:\n',
    Tim3: "1. Welcome to the Navigator's challenge, send activity gifts to earn nautical diamond, you can sail. Ordinary gifts: 1 gold coins =1 diamond, lucky gifts 1 gold coins =0.1 diamond.\n",
    Tim4: '2. this voyage route for the shore - Arabian Sea - Red Sea - Persian Gulf, each sea has its own nautical diamond requirements, to meet the requirements can reach the sea.\n',
    Tim5: "3. each sea can be deep-sea fishing, fishing can get the chance to draw the prize pool below, the prize pool will be more and more luxurious. The sea can't be fished until it's unlocked. Navigation page diamond are not deducted.\n",
    Tim6: "4. the ranking according to the nautical diamond ranking, the navigator's ranking of the first can climb the top of the best navigator display position, real-time update.\n",
    Tim7: '5. If the user is suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification.\n',
    Tim8: '6. Miparty Live reserves the right of final interpretation of this event. This event has nothing to do with Apple. Live has the final right to interpret the event, which has nothing to do with Apple',
    Con: 'Congratulations',
    Con5: 'Congratulations on arriving at',
    Con0: 'and earning your prize!',
    Con6: 'Confirm',
    Con7: 'Congratulations on receiving the following awards!',
    Rec: 'Receive',
    Ava: 'Available diamond:',
    poi: '10000 diamond\n* 1 time',
    poi8: '100000 diamond \n* 10 times',
    Com: 'Come and unlock more sea rewards!',
    Onl: 'Only the previous voyage to the corresponding section can unlock the corresponding prize pool !',
    Rew9: 'Rewards Pool',
    xxx: ' diamond are needed to unlock the second prize pool',
    xxx10: ' diamond are needed to unlock the third prize pool',
    Con11: 'Congratulations on receiving the following awards!',
    Con12: 'Confirm',
    Kee: 'Keep moving',
    You: 'You are currently short of diamond and need to send activity gifts to earn diamond for deep sea fishing!',
    Back: 'Back',
    Rew13: 'Rewards Records',
    Rec14: 'Received',
    Time: 'Time',
    Con15: 'Congratulations on your arrival in the Persian Gulf, you can continue to send activity gifts to participate in the prize pool.',
    Nav16: 'Navigator Rewards',
    more: 'more',
    Nav17: 'Navigator Top 1',
    Nav18: 'Navigator Top 2',
    Nav19: 'Navigator Top 3',
    Nav20: 'Navigator Top 4-10',
    Cha: 'Charm Top 1',
    Cha21: 'Charm Top 2',
    Cha22: 'Charm Top 3',
    Cha23: 'Charm Top 4-10',
    Poi: 'Diamond earned: xxxxx',
    Con24: 'Congratulations on your successful arrival in the {海域名称} ! Go and claim your prize!',
    Con25: 'Congratulations on your headwear xx* days, Medal xx* days, and ride xx* days',
    Days6: 'days',
    shore: 'shore',
    lucky: 'lucky',
    Mlucky: 'M-lucky',
    The8: 'The current area reward has been unlocked',
    Cha8: 'Charm Rewards',
    diamond: 'diamond',
    Charm: 'Charm',
  },
  // 钻石
  diamond: {
    Dia: 'Diamonds',
    Sel: 'Select',
    Myd: 'Diamond',
    Myr: 'Reseller diamond',
    Exc: 'Exchange',
    Wit: 'Withdraw',
    Tra: 'Transfer',
    Bill: 'Bill',
    Inc: 'Income',
    Total: 'Summary',
    Gif: 'Gift Income',
    Off: 'Official reward',
    Com: 'Commission',
    Oth: 'Other Income',
    Exp: 'Expenses',
    Wth: 'Withdraw',
    Dia1: 'Exchange Coins',
    Dia2: 'Diamond Transfer',
    Oth3: 'Others',
    Today: 'Today',
    Yes: 'Yesterday',
    Thi: 'This week',
    Las: 'Last week',
    Thi4: 'This month',
    Las5: 'Last month',
    Ple: 'Please select diamond amount',
    Det: 'Details',
    Coins: 'Coins',
    Con: 'Confirm',
    Myd6: 'Diamonds',
    Myr7: 'Reseller diamond',
    Total8: 'Total',
    Nom: 'No more',
    Dat: 'Date selection',
    Con9: 'Confirm',
    Can: 'Cancel',
    Con10: 'Confirm to use {var1} diamonds to exchange for {var2} coins or not',
    Exc11: 'Exchange rate',
    Amo: 'Amount details',
    Amo12: 'Amount',
    Cha: 'Charge fee',
    Pay: 'Payment method',
    Exc13: 'Exchange for coins',
    Dia14: 'Diamond withdrawal',
    Per: 'Personal withdrawal',
    Age: 'Agent withdrawal',
    Age15: 'Agent ID',
    Ple16: 'Please bind your payment account',
    Nee: 'Need to finish personal authentication first',
    Ord: 'Order ID',
    Name: 'Name',
    Add: 'Address',
    Email: 'Email',
    Con17: 'Contact number',
    Ban: 'Bank name',
    Ban18: 'Bank number',
    Acc: 'Account',
    Code: 'Code',
    Ban19: 'Bank card number',
    Oth20: 'Others',
    Wit21: 'Withdrawal time',
    Pen: 'Pending transfer',
    Wai: 'Waiting for confirmation',
    Suc: 'Success',
    Use: 'Retransfer in progress',
    Scr: 'Screenshot error',
    Off22: 'Official processing',
    Rej: 'Rejected more than 2 times',
    Fre: 'Freeze',
    Wit23: 'Withdrawal returned',
    Wai24: 'Agent confirming',
    Iss: 'Issued by Agency Owner',
    Wit25: 'Withdrawal completed',
    Age26: 'Agent rejects',
    Res: 'Reseller rejects',
    Wit27: 'Withdrawal in progress',
    Wai28: 'Waiting for confirmation',
    Con29: 'Confirmed',
    Age30: 'Agent has exchanged coins',
    Dia31: 'Diamond transfer',
    Tra32: 'Transfer to',
    Use33: 'User ID',
    Dia34: 'Diamond transfer requires xxx charge fee',
    Ple35: 'Please confirm the reseller to transfer',
    Cha36: 'Channel',
    Res37: 'Reseller ID',
    Note: 'Note',
    Coi: 'Coin reseller list',
    Dia38: 'Diamond bill',
    Gif39: 'Gift',
    Exp40: 'Expenses',
    Oth41: 'Others',
    Rec: 'Receivers',
    All: 'All',
    Off42: 'Official deductions',
    Hos: 'Host tasks',
    Off43: 'Official Reward',
    Ran: 'Ranking rewards',
    Wit44: 'Withdrawal return',
    Inv: 'Invitation tasks',
    Voi: 'Voice calls',
    Age45: 'Agent withdraws diamonds',
    Hos46: 'Host transfers diamonds',
    Age47: 'Agent ID',
    Tra48: 'Transfer ID',
    Dia49: 'Diamond transfer records',
    Bind: 'Bind',
    Loa: 'Loading',
    Cop: 'Copy successfully',
    Tra50: 'Transfer voucher',
    Not: 'Not received',
    Con51: 'Confirm received',
    Are: 'Are you sure you have received the transfer?',
    Ifn: 'If not confirmed within 24 hours, the transfer will be received by default',
    Ord52: 'Order feedback',
    Fee: 'Feedback content',
    Ple53: 'Please describe the problem and situation you encountered in detail. Thank you for your valuable suggestions',
    Upl: 'Upload picture',
    Sub: 'Submit',
    Cur: 'Currently only supports uploading {var1} pictures',
  },
  alAdha: {
    // 宰牲节
    Eid: 'Eid al-Adha',
    Con: 'Congratulations to ',
    Con1: "'s farm for successfully upgrading to LV",
    Rules: 'Rules',
    xda: 'xdays:x:x',
    Act: 'Activity Gifts',
    liv: 'livestock',
    Ran: 'Ranking',
    How: 'How to play?',
    How2: 'Give event gifts to accumulate diamond, ordinary gifts: 1coin =1diamond, lucky gifts: 1coin =0.1 diamond, buy items to feed livestock, help them grow up quickly! \nEarn diamond for completing daily task or giving activity gifts, so go feed your livestock !',
    Myp: 'My diamond：',
    Lvx: 'Lv.x',
    goose: 'goose',
    sheep: 'sheep',
    cat: 'cattle',
    camel: 'camel',
    Com: 'Complete LV',
    Com2: ' to get your own unique mysterious gift~',
    poi: '*3000diamond',
    poi3: '*8000diamond',
    poi4: '*20000diamond',
    time: '1time',
    times: '10times',
    Dai: 'Daily task',
    Dai5: 'Daily sign in(0/1) +1000diamond',
    sig: 'sign in',
    Dai6: 'Daily watch living 10mins(0/1) +1500diamond',
    Tof: 'To finish',
    Sen: 'Send 10000diamond activity gifts＋2000diamond',
    Tof7: 'To finish',
    Acc: 'Accumulated recharge 150000 coins\nAgent recharge is not included',
    Tof8: 'To finish',
    Bob: 'Miparty reserves the right of final interpretation of this activity ，This event is not affiliated with Apple.',
    Rul1: '1. You can participate in pasture farming by sending activity gifts;\n',
    Rul2: '2. Give event gifts to accumulate diamond, lucky gifts: 1coin =0.1diamond, general gifts:1coin =1diamond, buy props to feed livestock, prepare for Eid al-Adha!\n',
    Rul3: '3. Rank\nSender rank -- the cumulative value of gold coins given during the event;\nCharm rank -- the cumulative value of gold coins received during the event;\n',
    Rul4: '4. Activity rewards will be sent within 3 working days after the end of the activity;\n',
    Rul5: '5. Miparty reserves the right to erase activity data and rewards if it is suspected of obtaining rewards by illegal means.',
    Con9: 'Congratulations on your xxx growing up! Moving on to the next level!',
    You: "You're running low on diamond, send out the activity gifts to feed the livestock!",
    Rew: 'Reward',
    Fee: 'Feed your livestock to maturity and receive the following rewards!',
    Hea: 'Headwear*xx',
    Rid: 'Ride*xx',
    Bad: 'Badge*xx',
    Tas: 'Task Completed',
    Sho: 'Show More',
    Con8: 'Congratulations',
    Con19: 'Congratulations on receiving the following rewards!',
    The: 'The feed is full',
    Dai8: '1. Daily list - Accumulate the highest ranking of event gifts sent on the day;',
    Gen: '2. General list--accumulative event gifts sent during the event.',
    Sen9: 'Sender Rank',
    Sen2: 'Sender Top',
    Ref: 'Refresh',
    Cha: 'Charm Top',
    Sen3: 'Send 10000 diamond activity gifts',
    Dai3: 'Daily sigh in',
    Dai2: 'Daily watch living 10 mins',
    Cha2: 'Charm Rank',
  },
  appTransferDetail: {
    Coi: 'Coins agent id',
    Rem: 'Remark',
    Poi: 'Diamond transfer details',
    Tra: 'Transfer',
    Tra1: 'Transferring',
    Coi2: 'Coins agent rejected',
    Poi3: 'Diamond return',
    Con: 'Confirming',
    Ret: 'Retransfer in progress',
    Com: 'Completed',
    Tra4: 'Transfer proof',
    Tra5: 'Transfer received',
    Did: 'Did not received or other reasons',
    Ifn: 'If not confirmed within {x} hours,the transfer will be received by default',
    Pay: 'Payroll',
    Tot: 'Total payment amount',
    Poi6: 'Diamond received',
    Pla: 'Platform rewards received',
    Wai: 'Waiting for diamond to be confirmed',
    Wai7: 'Waiting for transfer',
    Pen: 'Pending',
    Com8: 'Completed',
    Other: 'Other',
    Agent: 'Agent',
    Per: 'Person',
    No: 'No.',
    Use: 'User Information',
    Ord: 'Order id',
    Det: 'Details',
    Sta: 'Status',
    Cou: 'Countdown',
    Poi9: 'Diamond received',
    Pla10: 'Platform rewards',
    Ope: 'Operate',
    Rej: 'Reject',
    Tra11: 'Transfer',
    You: 'You need to process this order within {1} hours',
    Ord12: 'Order information',
    con: 'Confirm',
    Pen13: 'Wait for confirmation',
    Use14: 'User did not receive',
    Rep: 'Reprocessing',
    The: 'The user needs to confirm the order within {1} hours.If it is not confirmed within the time limit,it will be automatically confirmed.If you have any questions,please contact customer service in time',
    Tra15: 'Transfer time',
    Off: 'Officially settled',
    Ord16: 'Order frozen',
    Off17: 'Official return',
    Ord18: 'Order has been transferred',
    Rej19: 'Rejected',
    Fin: 'Financial release',
    Ple: 'Please search for id',
    Sea: 'Search',
    Rec: 'Received',
    Not: 'Not received',
    Num: 'Number of agencies',
    Tot20: 'Total earnings',
    Tot21: 'Totall commission',
    Inv: 'Invited level',
    Age: 'Agency Information',
    Age22: 'Agent ID',
    Joi: 'Join Time',
    Hos: 'Host earings',
    Com23: 'Commission rate',
    MyC: 'My Commission',
    Inv24: 'Invited agency earnings',
    Mya: 'My agency earnings',
    Mys: 'My sub-agency earnings',
    Num25: 'Number of sub-agencies',
    Cal: 'Call income',
    Act: 'Active days',
    Liv: 'Live broadcast time',
    Audio: 'Audio',
    Sol: 'Solo Live',
    Mul: 'Multi-guest Live',
    Amo: 'Amount',
    Att: 'Attention, you have reached the daily recharge limit',
    Cur: 'Currently, recharging this option is not supported.',
    Arr: 'Arrival: {} hours',
    Bind: 'Bind',
    exc: 'exchange rate',
    Wit: 'Withdrawal Method',
    ple: 'please choose country or region',
    sea: 'search',
    sea26: 'search country',
    Name: 'Name',
    Add: 'Address',
    Email: 'Email',
    Pho: 'Phone Number',
    Ban: 'Bank Name',
    Ban27: 'Bank Code',
    Acc: 'Account',
    Code: 'Code',
    Ban28: 'Bank Account',
    Oth: 'Others',
    Remit: 'Remit',
    Inc: 'Income from this order',
    Order: 'Order',
    Pay29: 'Payment method',
    Ple30: 'Please make the payment before the end of the countdown. Failed to make payment on time will affect the amount of orders given to you.',
    Tot31: 'Total income',
    tra: 'transaction completion time',
    Tra32: 'Transfer not received or other reasons',
    The33: 'The screenshot is wrong. If you have any questions, please contact the official',
    Wit34: 'Withdrawals record',
    Wit35: 'Withdrawn',
    Ret36: 'Retransfer in progress',
    Acc37: 'Account information error',
    Amo38: 'Amount Details',
    Wit39: 'Withdrawal time',
    Pay40: 'Payment proof',
    Rea: 'Reason',
    Ple41: 'Please describe the problem and situation you encountered in detail',
    Upl: 'Upload image (optional)',
    The42: 'The order-taking switch is not turned on',
    Noo: 'No order',
    Too: 'Too many outstanding orders',
    Suc: 'Successful operation',
    Con43: 'Confirm that the transfer has been received',
    Pay44: 'Payroll',
    Fee: 'Fee',
    Today: 'Today',
    Yes: 'Yesterday',
    Thi: 'This month',
    Las: 'Last month',
    Thi45: 'This week',
    Las46: 'Last week',
    sel: 'select date',
    Pay47: 'Payment amount',
    poi: 'diamond of earning',
    Pla48: 'Platform Rewards',
    Tak: 'Take order now',
    Pen49: 'Pending \npayment({})',
    Pen50: 'Pending payment',
    Tob: 'To be confirmed \nby hosts ({})',
    ord: 'order id',
    cha: 'channel',
    amo: 'amount',
    ope: 'operate',
    wit: 'withdrwal time',
    tak: 'take order',
    pen: 'pending transfer',
    ON: 'ON',
    OFF: 'OFF',
    Upl51: 'Upload payment proof',
    ple52: 'please upload payment proof',
    Con53: 'Confirmation of payment',
    dro: 'drop order',
    are: 'are you sure to drop this order',
    scr: 'screenshot:\norder id:\namount:\nwithdrwal time:\nchannel:\naccount/bank info:',
    Ift: 'If the status is not modified within 24 hours, the transfer will be received by default.',
    You54:
      'You spent {积分数} to withdraw {提现金额} US dollars at {时间}. The money has been successfully transferred to your payment account. Please select the order status after checking.\n(If the status is not modified within 24 hours, the transfer will be received by default).',
    Tra55: 'Transfer received',
    Tra56: 'Transfer not received',
    Rea57: 'Reason',
    The58: 'The user has confirmed receipt of the transfer.',
    Ord59:
      "Order transaction failed:\n\nPlease re-upload the screenshot after confirmation: Wait for the host's confirmation - Modify the screenshot\nIf you have any questions, please contact the official.",
    Scr: 'Screenshot error',
    Con60: 'Confirming',
    Tra61: 'Transaction failed',
    Tra62: 'Transaction complete',
    Check: 'Check',
    com: 'commission',
    Mod: 'Modify screenshot',
    Total: 'Total',
    NoData: 'No data',
    AgencyCode: 'Agency Code',
    FeedbackContent: 'Feedback content',
    rejection: 'Please enter the reason for rejection',
    screenshot: 'Please upload a screenshot',
  },
  agencyPayroll: {
    Coi: 'Coins agent id',
    Rem: 'Remark',
    Poi: 'Order Diamonds',
    Tra: 'Transfer',
    Tra1: 'Transferring',
    Coi2: 'Coins agent rejected',
    Poi3: 'Diamond return',
    Con: 'Confirm',
    Ret: 'Retransfer in progress',
    Com: 'Completed',
    Tra4: 'Transfer proof',
    Tra5: 'Transfer received',
    Did: 'Did not received or other reasons',
    Ifn: 'If not confirmed within {1} hours,the transfer will be received by default',
    Pay: 'Payroll',
    Tot: 'Total Payment',
    Poi6: 'Order Diamonds',
    Pla: 'Extra Rewards',
    Wai: 'Pending Diamonds',
    Wai7: 'Pending',
    Pen: 'Confirming',
    Com8: 'Completed',
    Other: 'Other',
    Agent: 'Agent',
    Per: 'Person',
    No: 'No.',
    Use: 'User Information',
    Ord: 'Order id',
    Det: 'Details',
    Sta: 'Status',
    Cou: 'Countdown',
    Poi9: 'Order Diamonds',
    Pla10: 'Platform rewards',
    Ope: 'Operate',
    Rej: 'Reject',
    Tra11: 'Transfer',
    You: 'You need to process this order within {xx} hours',
    Ord12: 'Order information',
    con: 'Confirm',
    Pen13: 'Wait for confirmation',
    Use14: 'Confirming',
    Rep: 'Reprocessing',
    The: 'The user needs to confirm the order within {xx} hours.If it is not confirmed within the time limit,it will be automatically confirmed.If you have any questions,please contact customer service in time',
    Tra15: 'Transfer time',
    Off: 'Officially settled',
    Ord16: 'Order frozen',
    Off17: 'Official return',
    Ord18: 'Order has been transferred',
    Rej19: 'Rejected',
    Fin: 'Financial release',
    Ple: 'Please search for id',
    Sea: 'Search',
    Rec: 'Received',
    Not: 'Not received',
    Num: 'Number of agencies',
    Tot20: 'Total earnings',
    Tot21: 'Totall commission',
    Inv: 'Invited level',
    Age: 'Agency Information',
    Age22: 'Agent ID',
    Joi: 'Join Time',
    Hos: 'Host earings',
    Com23: 'Commission rate',
    MyC: 'My Commission',
    Inv24: 'Invited agency earnings',
    Mya: 'My agency earnings',
    Mys: 'My sub-agency earnings',
    Num25: 'Number of sub-agencies',
    Cal: 'Call income',
    Act: 'Active days',
    Liv: 'Live broadcast time',
    Audio: 'Audio',
    Sol: 'Solo Live',
    Mul: 'Multi-guest Live',
    Amo: 'Amount',
    Att: 'Attention, you have reached the daily recharge limit',
    Cur: 'Currently, recharging this option is not supported.',
    Arr: 'Arrival: {} hours',
    Bind: 'Bind',
    exc: 'exchange rate',
    Wit: 'Withdrawal Method',
    ple: 'please choose country or region',
    sea: 'search',
    sea26: 'search country',
    Name: 'Name',
    Add: 'Address',
    Email: 'Email',
    Pho: 'Phone Number',
    Ban: 'Bank Name',
    Ban27: 'Bank Code',
    Acc: 'Account',
    Code: 'Code',
    Ban28: 'Bank Account',
    Oth: 'Others',
    Remit: 'Remit',
    Inc: 'Income from this order',
    Order: 'Order',
    Pay29: 'Payment method',
    Ple30: 'Please make the payment before the end of the countdown. Failed to make payment on time will affect the amount of orders given to you.',
    Tot31: 'Total income',
    tra: 'transaction completion time',
    Tra32: 'Transfer not received or other reasons',
    The33: 'The screenshot is wrong. If you have any questions, please contact the official',
    Wit34: 'Withdrawals record',
    Wit35: 'Withdrawn',
    Ret36: 'Retransfer in progress',
    Acc37: 'Account information error',
    Amo38: 'Amount Details',
    Wit39: 'Withdrawal time',
    Pay40: 'Payment proof',
    Rea: 'Reason',
    Ple41: 'Please describe the problem and situation you encountered in detail',
    Upl: 'Upload image (optional)',
    The42: 'The order-taking switch is not turned on',
    Noo: 'No order',
    Too: 'Too many outstanding orders',
    Suc: 'Successful operation',
    Con43: 'Confirm that the transfer has been received',
    Pay44: 'Payroll',
    Fee: 'Fee',
    Today: 'Today',
    Yes: 'Yesterday',
    Thi: 'This month',
    Las: 'Last month',
    Thi45: 'This week',
    Las46: 'Last week',
    sel: 'select date',
    Pay47: 'Payment amount',
    poi: 'diamond of earning',
    Pla48: 'Platform Rewards',
    Tak: 'Take order now',
    Pen49: 'Pending \npayment({})',
    Pen50: 'Pending payment',
    Tob: 'To be confirmed \nby hosts ({})',
    ord: 'order id',
    cha: 'channel',
    amo: 'amount',
    ope: 'operate',
    wit: 'withdrwal time',
    tak: 'take order',
    pen: 'pending transfer',
    ON: 'ON',
    OFF: 'OFF',
    Upl51: 'Upload payment proof',
    ple52: 'please upload payment proof',
    Con53: 'Confirmation of payment',
    dro: 'drop order',
    are: 'are you sure to drop this order',
    scr: 'screenshot:\norder id:\namount:\nwithdrwal time:\nchannel:\naccount/bank info:',
    Ift: 'If the status is not modified within 24 hours, the transfer will be received by default.',
    You54:
      'You spent {积分数} to withdraw {提现金额} US dollars at {时间}. The money has been successfully transferred to your payment account. Please select the order status after checking.\n(If the status is not modified within 24 hours, the transfer will be received by default).',
    Tra55: 'Transfer received',
    Tra56: 'Transfer not received',
    Rea57: 'Reason',
    The58: 'The user has confirmed receipt of the transfer.',
    Ord59:
      "Order transaction failed:\n\nPlease re-upload the screenshot after confirmation: Wait for the host's confirmation - Modify the screenshot\nIf you have any questions, please contact the official.",
    Scr: 'Screenshot error',
    Con60: 'Confirming',
    Tra61: 'Transaction failed',
    Tra62: 'Transaction complete',
    Check: 'Check',
    com: 'commission',
    Mod: 'Modify screenshot',
    Total: 'Total',
    Fee63: 'Feedback content',
    Cre: 'Creation time',
    Hos64: 'Host number',
    Nod: 'No data',
    Age65: 'Agency Code',
    Ord66: 'Order taking',
    Nom: 'No more data',
    Wit67: 'Withdrawal time',
    Com68: 'Completion time',
    Ope69: 'Operation time',
    Pen70: 'Pending',
    Wit71: 'Withdrawal diamond',
    App: 'Application time',
    Age72: 'Agent exchanged coins',
    Wit73: 'Withdrawal completed',
    Ope74: 'Operation time (GTM+7)',
    Age75: 'Agent refused',
    Ret76: 'Returned by official',
    Refresh: 'Refresh successfully',
    Loading: 'Loading...',
    Pull: 'Pull-to-refresh',
    Release: 'Release to refresh',
    Bind2: 'Bind the guild',
    Thef: 'The following are the guilds you belong to Their withdrawals will be distributd by you Guild ID：',
    Ok: 'ok',
    Agen: 'Agency Code',
    Agen2: 'Agent ID',
    Bind3: 'Bind Agency Information',
    No2: 'No.',
    Agen3: 'Agency Name',
    Coun: 'Country',
    Room: 'Room Type',
    Bind4: 'Binding Time',
    Noma: 'No matching data found',
    Host: 'Host ID',
    Thef2: '** The following are the guilds you belong to.',
    Thei: 'Their withdrawals will be distributd by you.',
  },
  payroll: {
    // 代理代发
    Remit: 'Remit',
    Inc: 'Income from this order',
    Order: 'Order',
    Pay: 'Payment method',
    Ple: 'Please make the payment before the end of the countdown. Failed to make payment on time will affect the amount of orders given to you.',
    Tot: 'Total income',
    tra: 'transaction completion time',
    Tra: 'Transfer not received or other reasons',
    The: 'The screenshot is wrong. If you have any questions, please contact the official',
    Wit: 'Withdrawals record',
    Wit1: 'Withdrawn',
    Ret: 'Retransfer in progress',
    Acc: 'Account information error',
    Amo: 'Amount Details',
    Wit2: 'Withdrawal time',
    Pay3: 'Payment proof',
    Rea: 'Reason',
    Ple4: 'Please describe the problem and situation you encountered in detail',
    Upl: 'Upload image (optional)',
    The5: 'The order-taking switch is not turned on',
    Noo: 'No order',
    Too: 'Too many outstanding orders',
    Suc: 'Successful operation',
    Con: 'Confirm that the transfer has been received',
    Pay6: 'Payroll',
    Fee: 'Fee',
    Today: 'Today',
    Yes: 'Yesterday',
    Thi: 'This month',
    Las: 'Last month',
    Thi7: 'This week',
    Las8: 'Last week',
    sel: 'select date',
    Pay9: 'Payment amount',
    poi: 'diamond of earning',
    Pla: 'Platform Rewards',
    Tak: 'Take order now',
    Pen: 'Pending \npayment',
    Pen10: 'Pending payment',
    Tob: 'To be confirmed \nby hosts',
    ord: 'order id',
    cha: 'channel',
    amo: 'Amount',
    ope: 'operate',
    wit: 'withdrwal time',
    tak: 'take order',
    pen: 'pending transfer',
    ON: 'ON',
    OFF: 'OFF',
    Upl11: 'Upload payment proof',
    ple: 'please upload payment proof',
    Con12: 'Confirmation of payment',
    dro: 'drop order',
    are: 'are you sure to drop this order',
    scr: 'screenshot:\norder id:\namount:\nwithdrwal time:\nchannel:\naccount/bank info:',
    Ift: 'If the status is not modified within 24 hours, the transfer will be received by default.',
    You: 'You spent {积分数} to withdraw {提现金额} US dollars at {时间}. The money has been successfully transferred to your payment account. Please select the order status after checking.\n(If the status is not modified within 24 hours, the transfer will be received by default).',
    Tra13: 'Transfer received',
    Tra14: 'Transfer not received',
    Rea15: 'Reason',
    The16: 'The user has confirmed receipt of the transfer.',
    Ord: "Order transaction failed:\n\nPlease re-upload the screenshot after confirmation: Wait for the host's confirmation - Modify the screenshot\nIf you have any questions, please contact the official.",
    Scr: 'Screenshot error',
    Con17: 'Confirming',
    Tra18: 'Transaction failed',
    Tra19: 'Transaction complete',
    Check: 'Check',
    com: 'commission',
    Mod: 'Modify screenshot',
    conf: 'confirm',
    canc: 'cancel',
    cop: 'Copied successfully',
    excha: 'exchange rate',
    name: 'Name',
    Account: 'Account',
    Order6: 'Order transaction failed:',
    record: 'History',
    Nomore: 'No more data',
    Name: 'Name',
    Add: 'Address',
    Email: 'Email',
    Pho: 'Phone Number',
    Ban: 'Bank Name',
    Ban1: 'Bank Code',
    Acc0: 'Account',
    Code: 'Code',
    Ban2: 'Bank Account',
    Oth: 'Others',
    ordes: 'Confirm payment order',
    ifsc: 'Bank IFSC',
    Ples: 'Please choose reason',
    Use: 'User account information is wrong',
    Oths: 'Others',
    Oth1: 'Other reason description',
    Ple2: 'Please Upload Screenshot',
    Cons: 'Confirm',
    Can: 'Cancel',
    Age: 'Agency code',
    Status: 'Order status',
    Screenshot: 'Screenshot',
    Order7: 'Order transaction failed',
  },
  personalInfo: {
    Name6: 'Name',
    Add: 'Address',
    Email6: 'Email',
    Pho: 'Phone Number',
    Ban: 'Bank Name',
    Ban1: 'Bank Code',
    Acc: 'Account',
    Code: 'Code',
    Oth: 'Others',
    Ifsc: 'Bank IFSC',
    Card: 'Bank Account',
  },
  RaceCar: {
    Act: 'Activity has not started!',
    Act1: 'Activity has ended!',
    Rac: 'Racing Car Competition',
    Day: 'Days：Hours：Minutes：Seconds',
    Act2: 'Activity gifts',
    xxc: 'xx coins',
    Ord: 'Ordinary gifts: 1 gold coins =1 diamond, lucky gifts 10 gold coins =1 diamond.',
    Rac3: 'Racetrack',
    Dal: 'Daliy Racing Price Pool',
    Rank: 'Rank',
    Car: 'Car Center',
    LVX: 'LV.X',
    Win: 'Win rate:',
    Rac4: 'Racetrack',
    Nee: 'Need to cost 8000 diamond to enter a race.',
    Rac5: 'Racing Results',
    Rew: 'Reward',
    Ent: 'Enter the race',
    Myp: 'My diamond：',
    Myw: 'My winning races：',
    Tor: 'To reach top 10 you still need to win:',
    Spe: 'Speed Up Task',
    Ref: 'Refresh:',
    Sen: 'Send 10000 diamond activity gifts',
    Sen2: 'Send 50000 diamond activity gifts',
    Win6: 'Win 2 races',
    Upg: 'Upgrade 1 race car',
    Acc: 'Accumulated recharge 150000 coins \nAgent recharge is not included',
    XXX: '＋XXXdiamond',
    Tof: 'To finish',
    Fin: 'Finished',
    Bob: 'Miparty reserves the right of final interpretation of this activity .This event is not affiliated with Apple.',
    Rule: 'Rule',
    Tim: 'Time: ',
    Tim2: '\n7/7-7/16 ',
    Tim3: '\nRules: ',
    Tim4: "\n1. Ranking rewards will be sent to the winner's account within 3 working days after the activity ends ",
    Tim5: '\n2. During the event, all users can earn diamond to upgrade the car and receive upgrade rewards by sending activity gifts \n',
    Tim6: '3. The user can participate in the car race by costing diamond. The race has the probability of winning or losing. The winner will get the random champion award, and the loser will get the random encouragement award \n',
    Tim7: '4. Users can also obtain nitrogen props and diamond by completing speed up tasks, which can increase the rate of winning the race \n',
    Tim8: '5. The official will place 60,000 gold coins into the prize pool every day, and the diamond of users participating in the competition can be added to the prize pool proportionally. 10 users who participate in the competition and win more times per day can participate in the sharing \n',
    Tim9: '6. If users are suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification \n',
    Tim10: '7. The final interpretation of this activity is owned by the official, and this activity has nothing to do with Apple',
    Upg7: 'Upgrade Reward Preview',
    Hea: 'Headwear*X',
    Bad: 'Badge*X',
    RideX: 'Ride*X',
    Con: 'Congratulations',
    Con8: 'Congratulations on upgraded your car and received the following rewards!',
    Rec: 'Receive',
    Rec9: 'Received',
    Rac10: 'Racing Rules',
    Itc: '1. It costs 3000 diamond to participate in a race.\n',
    Itc2: '2. Complete the speed up task to obtain nitrogen props,using nitrogen can improve the winning rate of the race.\n',
    Itc3: '3. You can only use up to 3 nitrogen per match.\n',
    Itc4: '4. The winner of the competition will get the championship reward, the reward is random;Failure to compete is rewarded with encouragement prizes, which are random.',
    Rac11: 'Racing Results',
    Con12: 'Congratulations on winning the race and receiving the following rewards!',
    Con13: 'Confirm',
    Iti: 'It is a pity you lost the race and received the following reward!',
    You: 'Your Nitrogen：',
    Onl: 'Only a maximum of 3 nitrogen can be used per race.',
    Cur: 'Current Win Rate:',
    Con14: 'Confirm',
    Can: 'Cancel',
    Car15: 'Car',
    Res: 'Results',
    Rew16: 'Reward',
    Date: 'Date',
    Win17: 'Win',
    Lose: 'Lose',
    Rac18: 'Racing Reward',
    Win19: 'Winning may get you',
    Los: 'Losing may get you',
    How: 'How to play? ',
    How1: '1. Diamond consumed by participating in the race will be added to the prize pool in proportion.',
    How2: '2. The top 10 users who win more races each day will divide up proportionally.',
    Dai: 'Daily Prize pool',
    coins: '10000coins',
    Bes: 'Best Racer',
    Charm: 'Charm',
    Ran: 'Ranking Reward',
    TopX: 'TopX',
    more: 'more',
    enough: 'The current diamond is not enough, can not enter the race',
    Hea30: 'Headwear',
    Sha: 'Shards',
    Bad31: 'Badge',
    RideX32: 'Ride',
    XXX57: ' diamond',
    Act27: 'Activity gifts',
    coins2: ' coins',
  },
  firstMeetingCP: {
    Fir: 'First Meeting CP',
    Act: 'Activity time: 4/15-5/15',
    CPh: 'CP home',
    Wis: 'Wishing Pool',
    Aus: 'A user has sent you an invitation for a week of CP experience, come and have a look!',
    You: 'You and your cp have completed one week of CP tasks, and the reward has been issued',
    Con: 'Congrats! You have completed all the tasks, the official binding CP gift has been issued to your backpack, please check!',
    You1: 'Your one week CP relationship has been cancelled',
    You2: 'Your CP has removed CP from you and the home is no longer valid.',
    Sen: 'Send or receive specified gifts in the CP gift column to get a one-week cp experience~',
    MyO: 'My One-week CP',
    Sen3: 'Send Gift 1coin = 1<div class="tick"></div>,send Lucky Gift 10coins =1<div class="tick"></div>',
    Swi: 'Switch',
    Can: 'Cancel relationship',
    Task: 'Task',
    Com: 'Complete all tasks to getn an official binding cp gift',
    Vis: "Visit your friend's cp home once a day",
    can: '（can only be done once a day）',
    Sig: 'Sign in with cp for 3 consecutive days',
    Sta: 'Stay in the room for 15 minutes at the same time ',
    Sen4: 'Send cp gifts to cp to 8000 points',
    Des: 'Description',
    Giv1: "1. Give or receive specified cp column gifts to experience CP for a week, you can open cp homes to get pets to upgrade, you can also participate in Cupid's Wishing Pool in Sweet CP\n(Note: Pets with weekly CP can only rise to 1 level, and Cupid's Wishing Pool can only participate in the primary Wishing Pool)\n\n",
    Giv2: '2. You can get rewards for completing tasks with your weekly CP. After completing all tasks, you can get an official binding CP gift, which will be sent directly to your backpack, and if you send the gift, you can officially become CP!\n\n',
    Giv3: '3. Points earned during one week of CP experience will not count towards the Sweet CP rank\n\n',
    Giv4: '4. If the CP relationship ends in one week, the CP home will automatically become invalid; If it is formally bound into CP, CP homes will maintain the current progress and from the time of formal binding, points are calculated into the rank\n\n',
    Giv5: '5. If users are suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification\n\n',
    Giv6: '6. The final interpretation of this activity is owned by the official, and this activity has nothing to do with Apple.Inc',
    Cli: "Click here to Cupid's Wishing Pool\n",
    One: 'One week CP official binding gift',
    The: 'There is currently no one-week CP',
    Are: 'Are you sure to cancel the one-week cp relationship with this user?',
    Con5: 'Confirm',
    Wait: 'Wait',
    Myp: 'My package',
    User: 'User',
    Bin: 'Binding gift',
    Date: 'Date',
    You6: 'You have not received formally bound cp gift yet',
    You7: "You haven't had a one-week cp experience yet",
    Hea: 'Headwear*{x}',
    Bad: 'Badge*{x}',
    Ridex: 'Ride*{x}',
    Hea2: 'Headwear',
    Bad2: 'Badge',
    Ridex2: 'Ride',
    more: 'more',
    Ran: 'Ranking Reward',
  },
  cpResident: {
    Bob: 'Bobbo Sweet Couple',
    Pri: 'Primary',
    Int: 'Intermediate',
    Adv: 'Advanced',
    Con: 'Congrats!You and your CP ranked TOP1 on the daily CP rank and were displayed at the top of the activity!',
    Con1: 'Congrats! You and your CP won the weekly rank Top [x], 2X Experience card * [a] h, headwear * [b], badge* [c] have been issued, please check!',
    Con2: 'Congrats! You and your CP won the weekly rank Top [x], ride*【t】，2X Experience card * [a] h, headwear * [b], badge* [c] have been issued, please check!',
    You: 'Your [z] Wishing Pool has been unlocked, come and participate!',
    Can: 'Cannot participate in the Wishing Pool without cp currently',
    Sen: 'Send or receive the gift“Rose Love Ring”,you both can become CP',
    Rule: 'Rule',
    Ran: "1.The ranking rewards will be sent to the winners' accounts within 3 working days after the event ends\n\n2.During the event period, all users can bind CP by sending designated gifts. Send gifts：1coin = 1 heart，lucky gift：10coins=1heart. The heart values of unbound CP will not be included in the ranking list (unbound CP will not be able to use Dream Coins to participate in the Cupid Wishing Pool).\n\n3. Gift CP will get love value, daily TOP1 CP will be displayed at the top.The TOP3CP of the week will be rewarded, and the weekly ranking will be reset every week\n\n4.1 Heart value =1 Dream Coin. In CP, the giver will share 70% of the Dream Coin proportionally, and the recipient will share 30%. The Dream Coin can be used to participate in the Cupid Wishing Well\n\nThere are three levels of the wishing Pool. The intermediate and advanced wishing pools can only be unlocked by giving gifts to the designated points. A couple can only participate in the primary wishing pool for a week\n\n6. Wishing well points are refreshed and reset weekly\n\n7. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event\n\n8. The final interpretation right of this activity belongs to the official. This activity has nothing to do with Apple.Inc",
    Rank: 'Rank',
    Dai: 'Daily Rank',
    Dai3: 'Daily CP Top1 will be displayed at the top',
    Wee: 'Weekly Rank',
    Wee4: 'Weekly CP TOP {X}',
    ban: 'banner display',
    Cus: 'Custom ride',
    xEx: '2x Exp Card*Xh',
    XEx: '2X Exp Card',
    Exp: '1. Experience Card can be used in your CP home, by feeding your pet can get home experience points upgrade space \n2. Experience Card has a time limit, and the experience card will be effective from the time of daily settlement \n3. When the Experience card reward period expires, CP Home experience will return to normal',
    Hal: 'Hall Of Fame',
    LvX: 'Lv.X',
    Unb: 'Unbound CP cannot be counted in the rank',
    One: 'One week CP can not be included in the rank, send gift to become an official CP',
    Tos: 'To see more',
    Las: 'Last 6 weeks Top3 CP',
    Cup: "Cupid's Wishing Pool",
    Myw: 'My wish coin',
    Pri5: 'Primary',
    Int6: 'Intermediate',
    Adv7: 'Advanced',
    Wish: 'Wish*1',
    Wish8: 'Wish*10',
    Ble: 'Blessing Value',
    Eac: 'Each empty draw will accumulate 1 blessing value, reach the specified blessing value of each wishing pool can obtain the corresponding ride, after obtaining the ride will be re-accumulated blessing value',
    Rew: 'Reward',
    XXX: '{XXX}coins gift',
    Sen9: 'Send gifts to {xxx} points to unlock the wishing pool',
    Cur: 'Currently there is no binding CP',
    Not: 'Not enough Dream Coins',
    The: 'The current CP is one week CP and can only experience the primary Wishing pool',
    Can10: 'Cannot participate in the Wishing Pool without cp currently',
    Con11: 'Congrats!You have wished for the following rewards!',
    Kee: 'Keep wishing*{X}',
    Back: 'Back',
    Sor: 'Sorry, this wish is empty, has been counted in 1 blessing value!',
    Empty: 'Empty',
    You12: 'You have wished for the following rewards and {XX} times empty',
    His: 'History',
    Rew13: 'Reward',
    Date: 'Date',
    Con14: 'Congratulations, you have accumulated the blessing value of {X} Wishing pool, the reward has been issued, please check!',
    Des: 'Description',
    Get1: '1. Get points for sending gifts <div class="tick"></div>, 1<div class="tick"></div>=1<div class="tick2"></div>\n\n',
    Get2: '2. Dream coins are owned by oneself and divided according to CP points in proportion, the giver gets 70% and the recipient gets 30%\n\n',
    Get3: '3. Primary Wishing pool is unlocked by default, intermediate and advanced wishing pool need to send gifts to the specified points to unlock\n\n',
    Get4: '4. The points for the Trevi Fountain reset weekly\n\n',
    Get5: '5. Each empty draw will accumulate 1 blessing value, reaching the specified blessing value of each wishing pool can obtain the corresponding ride',
    Go: 'Go',
    Fin: 'Finished',
    sig: 'sign in',
    sig15: 'signed',
    mycp: 'My CP',
    Gif: 'Gift name',
    Wee2: 'Weekly CP Top1 will be displayed on the banner for a week',
    Ref: 'Refresh',
  },
  CpRank: {
    Days: 'Days',
    Hour: 'Hour',
    Minute: 'Minute',
    Second: 'Second',
    ThisWeek: 'This Week',
    LastWeek: 'Last Week',
    Day: '{0}day',
  },
  levelRewards: {
    Lev: 'Level Reward',
    The: '1.The higher the level, the richer the rewards，Some Rewards will be sent your account automatically,Some Rewards need you to check “get" to receive and Some Rewards need you to contact customer service.(Self-selected headwear & self-selected vehicle: Users need to contact customer service and select the corresponding product rewards in the mall.）',
    The1: '2. The customized ride will be designed based on the information you set on the platform, such as your nickname and id',
    Cus: '3. Customized headwear will be designed based on the information you set on the platform, such as your nickname and id',
    Mip: '4.Miparty has the final right to interpret the activity.',
    Byg: 'By giving gifts to friends , you increase your personal wealth, and with upgrade levels there are special rewards !(Wealth level only)',
    Get: 'Get All',
    Get2: 'Get',
    Con: 'Contact customer service',
    Con3: 'Congrats! You received all the following level rewards!',
    Ify: '*If you receive a VIP reward, the VIP will be valid at the same time as the VIP you currently have',
    Tog: 'To get pretty id',
    Rided: 'Ride*{0}d',
    Hea: 'Headwear*{0}d',
    Bad: 'Badge*{0}d',
    VIPxd: '{0}*{1}d',
    Pre: 'Pretty ID*1',
    Cel: 'Celebrity Gift',
    Sel: 'Self-selection Ride*{0}d',
    Sel4: 'Self-selection Headwear*{0}d',
    Lv: 'Lv{0}',
    LvB: 'Lv{0}Big Reward',
    Ify5: 'If you have senior vip, lower-levelvip Will take effect at the same time，Are you sure to get the VIP reward now?',
    Con6: 'Congratulations！You have got the following reward！',
    Whe: 'Whether to go get your personal Pretty ID？',
    Sure: 'Sure',
    Later: 'Later',
    Con7: 'Confirm',
    Got: 'Got',
    Hav: 'Have already received the gift',
    Des: 'Description',
    Cus2: 'Customized Ride*{0}d',
    Cus3: 'Customized Headwear*{0}d',
  },
  permissions: {
    '5': '',
    The: 'The application has been processed',
    The1: 'The ID is already the president, creation failed',
    The2: 'The president ID and username do not match',
    The3: 'The user has joined the agency',
    The4: 'The user has already been unbanned',
    '': '英语',
    Adv: 'Advanced permissions',
    Man: 'Management area',
    Age: 'Agency president',
    Age1: 'information certification',
    Ban: 'Ban management',
    Age6: 'Agency management',
    New: 'New applications',
    All: 'All applications',
    Ope: 'Operate',
    Rej: 'Reject',
    Pass: 'Pass',
    Age7: 'Agency name & ID',
    Cou: 'Country',
    IDc: 'ID card (front)',
    IDc8: 'ID card (back)',
    Ple: '*Please review according to the actual situation.',
    Thi: 'This application has been passed',
    Thi9: 'This application has been rejected',
    Thi10: 'This application has been processed',
    The11: 'The network is poor, please try again',
    Noa: 'No applications at the moment',
    Top: '*To protect privacy, all ID card images will be blurred after processing.',
    Ato: 'A total of {0} applications were processed',
    Fil: 'Filter',
    All12: 'All',
    Rej13: 'Rejected',
    Pas: 'Passed',
    Sta: 'Start time cannot be later than end time',
    Ban14: 'Ban management',
    Ban15: 'Ban lists (Me)',
    Ban16: 'Ban lists (All)',
    Ple17: '*Please consider unban carefully',
    Sea: 'Search by user ID or username',
    Sea18: 'Search',
    Use: 'User name&ID',
    Ban19: 'Ban type',
    Ban20: 'Ban reason',
    Other: 'Other',
    Ban21: 'Ban Time',
    Liv: 'Live ban',
    Acc: 'Account ban',
    Off: 'Official ban',
    Pol: 'Politically sensitive issue',
    Sex: 'Sexual harassment',
    Per: 'Personal abuse',
    Inv: 'Inviter',
    Can: 'Cancel',
    Unb: 'Unban successfully',
    The22: 'The network is poor, please try again',
    The23: 'The user has already been unbanned',
    You: '*You can only unban the corresponding users in your own management area',
    Nop: 'No permissions',
    Off24: 'Official ban',
    Age25: 'Agency management',
    Exp: 'Export',
    Sea26: 'Search by Agency ID or Agency name',
    Age27: '{0} Agency',
    Age271: 'Agency',
    Cre: 'Created(Me)',
    Cre1: 'Agency(All)',
    Age28: 'Agency Diamonds',
    Cre29: 'Create Time',
    Cur: 'Current total number of diamonds: {0}',
    Add: 'Add member',
    View: 'View members',
    Roo: 'Room type',
    Audio: 'Audio',
    Video: 'Video',
    Cre30: 'Create Time',
    Pre: 'President',
    Mem: 'Members',
    Dia: 'Diamonds',
    Cre31: 'Create agency',
    Age32: '【 Agency ID：{0}】Add Member',
    Age33: 'Agency :{0}',
    Ent: 'Enter the menber ID',
    Can34: 'Cancel',
    Add35: 'Add member',
    Con: 'Confirm to add this member?',
    Age36: '【 Agency ID：{0}】',
    Una: 'Unable to add the member',
    Con37: 'Confirm',
    Cover: 'Cover:',
    Pre38: 'President ID:',
    Ide: 'Identity :{0}',
    pre: 'president',
    host: 'host',
    none: 'none',
    Age39: 'Agency name:',
    Pre40: 'President’s username*:',
    Phone: 'Phone:',
    Age41: 'Agency Country:',
    Can42: 'Cancel',
    Cre43: 'Create',
    Cho: 'Choose country or region',
    Sea44: 'Search country',
    // 补充
    State: 'State',
    Pro: 'Processing time',
    Pul: 'Pull down to refresh...',
    Rel: 'Release to refresh...',
    Ref: 'Refresh Success',
    Loa: 'Loading...',
    Nom: 'No more...',
    Unban: 'Unban',
    Det: 'Details',
    From: 'From',
    Nul: 'Null data',
    Oth: 'Other reason：',
    Per1: 'Permission denied',
    Cover1: 'Cover',
    Ple11: 'Please select a picture',
    Ple1: 'Please enter',
    Pre1: 'President',
    Host: 'Host',
    Oth2: 'Other reason',
    Han: 'Hanging broadcast/black broadcast',
    The111: 'The president ID and username do not match',
    Pre3: 'President ID not confirmed',
    The41: 'The entered ID does not match the query result.',
    successfully: 'Add member successfully', // 添加成功
    Agency: 'Agency creacted successfully', // 创建成功
    Adding: 'Adding failed, please try again later', // 添加失败
    Thetime: 'The start time cannot be later than the end time.',
    Ok: 'ok',
    TheCurrent:
      'The current device already has the id entity of the president (President ID:{0}) and cannot be created. If you have any problems, please contact customer service',
    Bac: 'Background management',
    Gif: 'Gift management',
    Oth3: 'Other permissions',
    Bac1: 'Background check',
    Rec: 'Record',
    App: 'Application list',
    Add2: 'Add new',
    Sea2: 'Search by user ID',
    Sea3: 'Search',
    All2: 'All:',
    App3: 'Approved:',
    Rej2: 'Rejected:',
    Pen: 'Pending:',
    Use2: 'User Information',
    Bac4: 'Background',
    App5: 'Application Time',
    Act: 'Action',
    Pre2: 'Preview',
    Rej6: 'Reject',
    App7: 'Approved',
    App8: 'Approved',
    Rej9: 'Rejected',
    Ple2: 'Please enter Miparty ID',
    Bac10: 'Background name',
    Bac11: 'Background',
    Day: 'Day',
    Mes: 'Message',
    Rea: 'Reason',
    Ple12: 'Please enter a message to the user{0}',
    Ple13: 'Please enter the reason for giving to the user{0}',
    Save: 'Save',
    Ava: 'Avatar',
    Bac14: 'Background image',
    Rec15: 'Received days',
    Sen: 'Send reason',
    Sen16: 'Send message',
    Cre2: 'Creation time',
    Act17: 'Action',
    Edit: 'Edit',
    The5: 'There are unsaved changes.Do you want to save changes?',
    Can2: 'Cancel',
    Gif18: 'Gift Management',
    Sen19: 'Send Ride',
    Sen20: 'Send headwear',
    Sen21: 'Send badge',
    Sen22: 'Send vip',
    Type: 'Type',
    Off2: 'Official recommend',
    Bac23: 'Backpack',
    Name: 'Name',
    Val: '(Value:{0} Coins)',
    Sea24: 'Search',
    Send: 'Send',
    Vie: 'View the send record',
    Id: 'Id',
    Ava25: 'Avatar',
    Nic: 'Nickname',
    Pro2: 'Prop name',
    Pro26: 'Prop picture',
    Can27: 'Cancel',
    Use28: 'User information:',
    Use29: 'User avatar',
    Use30: 'User nickname',
    Use31: 'User country',
    Use32: 'User gender',
    male: 'male',
    fem: 'female',
    Roo2: 'Room cover',
    Roo33: 'Room title',
    Age2: 'Agency avatar',
    Age34: 'Agency name',
    Old: 'Old nickname',
    New2: 'New nickname',
    Old35: 'Old room title',
    New36: 'New room title',
    Old37: 'Old avatar',
    New38: 'New avatar',
    Old39: 'Old agency avatar',
    New40: 'New agency avatar',
    Old41: 'Old gender',
    New42: 'New gender',
    Old43: 'Old agency name',
    New44: 'New agency name',
    Old45: 'Old room cover',
    New46: 'New room cover',
    conf: 'confirm',
    canc: 'cancel',
    Days: '{0}Days',
    There: 'There is still unfilled content.',
    Doyou: 'Do you confirm approval?',
    Doyou2: 'Do you confirm rejection?',
    This: 'This record can only be modified once',
    Tot: 'Total Diamonds',
    Gif2: 'Gift Diamonds',
    Com: 'Commission Diamonds',
    Oth4: 'Other Rewards',
  },
  hallOfFame: {
    Mip: 'Hall Of Fame',
    Per: 'Personal Glory',
    Act: 'Activity Glory',
    Age: 'Agency Anniversary',
    Age1: 'AgentBirthday',
    Per2: '1.Personal honors include wealth lists, charm lists, game lists, and recharge lists. The ranking is updated in real time and settled monthly and annually\n\n2. The wealth list is ranked by the points users earn from gift-giving. Ordinary gifts are ranked at 1:1, and lucky gifts at 10:1. The Charm list is ranked based on the points users receive as gifts.Recharge list counts the number of gold coins in all recharge channels; The game ranking list is based on the amount of gold coins users have invested in all games\n\n3. The monthly list will be settled at 0:00 on the 1st day of every month (GMT+3) and will automatically issue rewards. The annual list will be settled at 0:00 on the 1st day of every January (GMT+3) and will automatically issue rewards.\n\n4.Please note: The monthly ranking of the recharge list will be settled at 0:00 (GMT+3) on the 2nd, and the annual ranking will be settled at 0:00 (GMT+3) on January 2nd each year, with rewards automatically issued\n\n5. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event.\n\n6. The final interpretation right of this activity belongs to the official. This activity has nothing to do with Apple inc.',
    Hom: 'Homepage',
    Wea: 'Wealth',
    Charm: 'Charm',
    Rec: 'Recharge',
    Game: 'Game',
    Jan: 'January',
    Feb: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
    Mon: 'Monthly Reward',
    Ann: 'Annual Reward',
    Nod: 'No data for this month',
    Nod3: 'No data for this year',
    Par: 'Par',
    Par1: '1. Participate in the activities of the platform and obtain the top 10 of the following activities to increase your glory points: \nLong-term activities include the TOP10 winners of Dreamy CP, starlight collection and recharge activities. \nShort-term activities are daily short-term activities on the platform. If you get the Top10 of the activity list, you will get glory points.',
    Par2: '2. By accumulating glory points, rankings will be made on the list. The annual list will be settled at 0:00 (GMT+3) on January 1st of each year, and corresponding list rewards will be automatically distributed',
    Par3: '3. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event. ',
    Par4: '4. The final interpretation right of this activity belongs to the official. This activity has nothing to do with Apple inc.',
    Lon: 'Long term activity (week end)',
    Lon4: 'Long term activity (month end)',
    Sho: 'Short-term activity',
    Ann5: 'Annual Activity Glory',
    Nod6: 'No data at present',
    Rec7: 'Record',
    Act8: 'Activity Name',
    MyR: 'My Ranking',
    Glo: 'Glory \nPoints',
    Set: 'Settlement Date',
    Noc: 'No current glory records',
    Ann9: 'Annual Activity \nGlory Top1',
    Get: 'Get the Top1 of the annual avtivity glory can be displayed in banner 365days',
    Joi: '1. Join the agency, and the system will celebrate the agency anniversary for you based on the registration date of the agency! \n\n2.On the anniversary day of the agency, the Agent and host of the corresponding agency will receive an anniversary gift package (if not claimed on that day, they can also click to claim it when entering the event page later). \n\n3. The final interpretation right of this activity belongs to the official. This activity has nothing to do with Apple inc.',
    Ble: 'Blessing Area',
    Hap: 'Happy anniversary!',
    The: '*The word limit is within 30 words',
    Send: 'Send',
    MyA: 'My Agency',
    Reg: 'Registration time:',
    Noh: 'No host certification, no agency info',
    Tod: "Today's celebration",
    st: '1st',
    nd: '2nd',
    rd: '3rd',
    th: '4th',
    th10: '5th',
    Agent: 'Agent',
    Top: 'Top3 Host',
    Upc: 'Upcoming Anniversary',
    Thi: 'This month',
    Ann11: 'Anniversary Gift',
    Noa: 'No anniversary agency celebration today',
    The12: 'There is no anniversary agency this month',
    Con: 'Congratulations',
    Con13: 'Congratulations! Your agency is celebrating its {0} anniversary! Click to receive the anniversary gift package!',
    You: 'You still have the agency anniversary rewards to claim! Click to get them now!',
    The14:
      "1. The agent can set a birthday date, and the platform will celebrate it for you!\n\n2.On the birthday of the agent, you will receive a birthday gift package. (If you don't claim it on that day, you can also click to claim it later by entering the page.)\n\n3. You can only claim the birthday gift package once a year. If you change your birthday date after claiming it in the same year, you cannot claim the birthday gift package again\n\n4. The final interpretation right of this activity belongs to the official. This activity has nothing to do with Apple inc.",
    Hap15: 'Happy Birthday！',
    Agent16: 'Agent',
    Bir: 'Birthday',
    Not: 'Not joined a agency or not created a agency',
    Tod17: "Today's Birthday Star",
    Bir18: 'Birthday Star',
    Fol: 'Follow',
    Fol2: 'Followed',
    The19: '*The birthday gift package can only be claimed once a year and the Agent can not claim the package again in the same year',
    Bir20: 'Birthday Gift',
    Upc21: 'Upcoming Birthday',
    Dea: 'Dear {0}\nToday is your birthday. Miparty has prepared a birthday gift package for you. Happy birthday to you!',
    Rec22: 'Receive blessings and gifts',
    Dea23: 'Dear {0} \nYou still have unclaimed birthday gift package rewards, click to get it!',
    Nob: 'No birthday information today',
    The24: 'There is no birthday this month',
    You25: 'Your text is over 30 words long',
    Par5: 'Participate in other activities to earn glory points',
  },
  // 荣耀竞技
  parisOlympic: {
    Par: 'Paris 2024 Summer Olympics',
    Act: 'Activity time：7/26 00:00-8/12 23:59 (GMT+7）',
    Tor: 'Torch Relay',
    Med: 'Medal Race',
    Dai: 'Daily Sign-in',
    Cum: 'Cumulative sign-in rewards',
    You: 'You have signed in for',
    You22: 'days！',
    Days: 'Days',
    Hea: 'Headwear*X',
    Bad: 'Badge＊X',
    RideX: 'Ride＊X',
    Rec: 'Receive',
    Sig: 'Sign in calendar',
    Joi: 'Join in daily sign-in to earn Olympic points~！',
    XXX: '＋XXXpoints',
    sig: 'sign in',
    Uns: 'Unsigned',
    res: 're-sign',
    Bob: 'Bobbo reserves the right of final interpretation of this acticity,this activity is not affiliated with Apple.',
    Thi: 'This phase of the activity is not available yet.',
    Con: 'Congrats! You have signed in for ',
    Conss: 'days and received corresponding rewards！',
    Sig4: 'Sign in Reward Preview',
    Back: 'Back',
    Con5: 'Congratulations',
    You6: 'You have successfully signed in and received XXX Olympic points',
    Con7: 'Confirm',
    Con8: 'Congratulations',
    You9: 'You have successfully signed in to received xxx Olympic points and the following rewards!',
    DayX: 'Day ',
    Itw: 'It will cost 800 gold coins to re-sign this time. \nConfirm to re-sign.',
    You10: 'You have resigned successfully~！',
    Tips: 'Tips',
    The: 'The current gold coins cannot be resigned, please recharge now.',
    Rec11: 'Recharge',
    Can: 'Cancel',
    Res: 'Re-sign in Rule',
    You12: 'You can re-sign with gold coins before the end of the activity.',
    Day: 'Day1-Day18: 800 gold coins per day',
    Rule: 'Rule',
    Tim: 'Time： ',
    Tim22: '7/26-8/12(GMT+7) \n',
    Tim33: 'Rules： \n',
    Tim44: "1. The final ranking reward will be sent to the winner's account within 3 working days after the activity; \n",
    Tim55: '2. During the activity, users can sign in daily to get Olympic points. If miss signing, users can resign by consuming gold coins; \n',
    Tim66:
      '3. Participate in activities and send event gifts to get points and Olympic shards. Ordinary gift: 10 gold coins =8 points, lucky gift: 20 gold coins =1 point; \n',
    Tim77: '4. Collected Olympic Shards can be exchanged at the Olympic Shop. \n',
    Tim88:
      '5. If the user is suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification; \n',
    Tim99: '6. The final interpretation of this activity is owned by the official, and this activity has nothing to do with Apple.Inc',
    Oly: 'Olympic Shop',
    Mys: 'My shards：',
    Use: 'Use your shards to exchange for rewards in the shop！',
    Exc: 'Exchange',
    Exc13: 'Exchange History',
    Are: 'Are you sure to exchange this item？',
    Cos: 'Cost Shards：',
    Con14: 'Confirm',
    Can15: 'Cancel',
    Con16: 'Congratulations',
    You17: 'You have successfully to exchange！',
    Back18: 'Back',
    You19: 'Your shards：XXX',
    The20: 'The current shards are not redeemable,go collect the shards~！',
    Con21: 'Confirm',
    Exc22: 'Exchange History',
    The23: 'There is no exchange history, go and collect　the shards to exchange!',
    Tor24: 'Torch Relay',
    Act25: 'Activity time：7/26 00:00-8/4 23:59 (GMT+7）',
    Day26: 'Days：Hours：Minutes：Seconds',
    Act27: 'Activity gifts',
    Ord: 'General gifts: 1coin =1energy, \n lucky gifts 10coin =1energy',
    Tor28: 'Torch Relay',
    MyO: 'My Olympic points:XXXX',
    Inv: 'Invalide',
    Pla: 'Place de la Concorde',
    Wel: 'Wellodham Stadium',
    Par29: 'Parc des Princes',
    Sta: 'Stade de France',
    Rew: 'Rewards',
    Hea30: 'Headwear',
    Sha: 'Shards',
    Bad31: 'Badge',
    RideX32: 'Ride',
    Dai33: 'Daily task',
    Ref: 'Refresh',
    Sha34: 'Daily Sign-in',
    Sign: 'Sign in',
    Sta35: 'Stay in the room for 15 mins',
    Dai36: 'Daily follow a host',
    Sen: 'Send 10000 points activity gifts',
    Sta37: 'Stage task',
    Dra: 'Draw blind Box 50 times in total',
    Lig: 'Light up 5 stadiums',
    Acc: 'Accumulated recharge 150000 coins.Agent recharge is not included',
    Tof: 'To finish',
    Fin: 'Finished',
    Rule38: 'Rule',
    Tim39: 'Time：',
    Tim392: '\n7/26 00:00-8/4 23:59 (GMT+7) \n',
    Tim393: ' Rules: \n',
    Tim394: "1. Ranking rewards will be sent to the winner's account within 3 working days after the activity; \n",
    Tim395:
      '2. During the activity, all users can earn points by sending activityt gifts to carry out the torch relay, sending ordinary gifts 10 gold coins=8points, lucky gifts 20 gold coins= 1 points; The torch relay lights up the Olympic venues for prizes and Olympic shards; \n',
    Tim396:
      '3. Each venue can draw the blind box, light the venue to unlock the corresponding level of blind box, blind box reward will be more and more luxurious. Venue page points will not be deducted. \n',
    Tim397:
      '4. The torch relay progress and list will be counted only when the activity gifts are sent or received during the activity. Each venue lighting reward needs to be collected on the activity page and can only be collected during the activity period. \n',
    Tim398:
      '5. If the user is suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification; \n',
    Tim399: '6. The final interpretation of this activity is owned by the official, and this activity has nothing to do with Apple.Inc',
    LVX: 'LV｛X｝ Torch Relay Reward',
    Rec40: 'Receive',
    Oly41: 'Olympic blind box',
    Ava: 'Available points：XXX',
    Unl: 'Unlock more advanced blind boxes and get　richer reward pools!',
    Xbl: 'blind　box',
    XXX42: ' points*1 time',
    XXX43: ' points*10 times',
    LvX: 'Reward Pool',
    Hea44: 'Headwear*X',
    Bad45: 'Badge＊X',
    RideX46: 'Ride＊X',
    Sha47: 'Shards*X',
    Bli: 'Blind box history',
    Nob: 'No blind box records yet.Go and draw blind box now~!',
    Kee: 'Keep relaying',
    You48: 'You are currently short of points and need to send activity gifts to earn points for Olympic blind box！',
    Back49: 'Back',
    Con50: 'Congratulations',
    Con51: 'Congratulations on receiving the following rewards!',
    Kee52: 'Keep shoting*1',
    Back53: 'Back',
    Kee54: 'Keep shoting*10',
    Kee30: 'Keep shoting*30',
    Tips55: 'Tips',
    Cur: 'Current blind box is locked. Relay the torch to light up the venue and unlock it!',
    Gor: 'Go relay',
    Later: 'Later',
    Rank: 'Rank',
    Tor56: 'Torchbearer',
    Charm: 'Charm',
    Ran: 'Ranking Reward',
    more: 'more',
    TOPX: 'TOP｛X｝',
    VIPX: 'VIP＊X',
    XXX57: ' diamond',
    energy: 'energy',
    coin: 'coins',
    Med58: 'Medal Race',
    Act59: 'Activity time：8/5 00:00-8/12 23:59 (GMT+7)',
    Bas: 'Basketball Match',
    Sho: 'Shooting has the probability of getting different progress values, reaching the specified progress value can light up the medal to get rewards!',
    Pro: 'Progress Value',
    air: 'air ball：',
    one: 'one-point shot: ',
    two: 'two-point shot: ',
    thr: 'three-point shot: ',
    Cur60: 'Current progress value：',
    XXX61: '5000 energy \n*1 time ',
    XXX62: '50000 energy \n*10 times',
    XXX63: '150000 energy \n*30 times',
    MyO64: 'My energy：',
    Sta65: 'Stage task',
    Max: 'Maximum combo reached 150',
    Win: 'Win a basketball match gold medal ',
    Acc66: 'Accumulated recharge XXXX coins \nAgent recharge is not included（0/XXXX）+XXXX points',
    Tof67: 'To finish',
    Fin68: 'Finished',
    Sho69: 'Shot Result',
    air70: 'air ball*X',
    one71: 'one-point shot*X',
    two72: 'two-point shot:*X',
    thr73: 'three-point shot*X',
    Pro74: 'Progress Value：xxx',
    kee: 'keep shoting*1',
    kee75: 'keep shoting*10',
    Con76: 'Confirm',
    You77: 'You are currently short of energy and need to send activity gifts to earn energy for shooting！',
    Bro: 'Bronze Medal Reward',
    Sil: 'Silver Medal Reward',
    Gol: 'Gold Medal Reward',
    Rec78: 'Receive',
    You79: 'You have successfully received your reward~',
    Bro80: 'Bronze Medal Reward Preview',
    Sil81: 'Silver Medal Reward Preview',
    Gol82: 'Gold Medal Reward Preview',
    Back83: 'Back',
    Rule84: 'Rule',
    Tim85: 'Time:\n',
    Tim852: '8/21 -8/28  (GMT+3)\n',
    Tim853: 'Rules:\n',
    Tim854: "1. Ranking rewards will be sent to the winner's account within 3 working days after the event;\n",
    Tim855:
      '2. During the event, all users can receive energy by sending event gifts to participate in the competition (ordinary gift: 1coin =1energy, lucky gift: 10coins =1energy), MEDALS can be obtained by participating in the competition;\n',
    Tim856: '3. Basketball competition: Shoot with energy to get progress value to compete for MEDALS, you can get rewards;\n',
    Tim857:
      '4. Lucky Football: send activity lucky gifts to get shooting points for combo, and the points of gifts with different values is different (shooting points = combo times * gift value*number of gifts).  The highest shooting points of the day is counted, and the score is reset every day;\n ',
    Tim858:
      '5. During the event period, the progress of the competition and the ranking list will only be tallied if event gifts are sent or received. Each medal lighting reward needs to be claimed on the event page and can only be claimed during the event period. Users who have not claimed it after the event will have it automatically issued by the system.\n',
    Tim859:
      '6. If the user is suspected of using illegal methods to brush data during the activity, the official has the right to clear the activity data and cancel the activity qualification;\n',
    Tim8510: '7. The final interpretation of this activity is owned by the official, and this activity has nothing to do with Apple.Inc',
    Luc: 'Lucky Football',
    Sen86:
      'Send the activity lucky gifts to get shooting points, different value of the lucky gift will have different points, reach a certain point can get medals reward.Shooting point daily reset.',
    Gof: 'Go for shoot',
    Mys87: 'My shooting points：',
    Ref88: 'Refresh',
    Sho89: 'Shooting points Rule',
    sho: 'shooting points = combo times * gift value*number of gifts',
    sho9020: 'shooting points = combo times * 30*number of gifts',
    sho9040: 'shooting points = combo times * 50*number of gifts',
    sho9080: 'shooting points = combo times * 30*number of gifts',
    sho9081: 'shooting points = combo times * 50*number of gifts',
    Rank91: 'Rank',
    Bes: 'Best Athlete',
    Charm92: 'Charm',
    Luc93: 'Lucky Football Shot',
    Sen94:
      "Send the activity lucky gifts to get shooting points, different value of the lucky gift will have different points.The ranking is based on the user's current highest shooting points.",
    sho95: 'shooting points = combo times * gift value*number of gifts',
    '': '',
    Con96: 'Congrats!You have signed in {X} days, go and get the reward now!',
    Con97: 'Congrats! You have successfully received {reward name}~',
    Con98: 'Congratulations on the successful exchange of {reward name} in the Olympic Shop~!',
    You99: 'You have successfully light {X}, blind box reward pool also upgraded ~ quick to receive and draw more generous rewards!',
    Con100: 'Congratulations! You have received Olympic Shards *x, headwear *x, Badge *x, ride *x!',
    Con101: 'Congratulations!You have light {A}, go and get the rewards ~!',
    Con102: 'Congratulations! You have received Olympic Shards *x, headwear *x, Badge *x, ride *x!',
    Congratula: 'Congratulations on receiving the following awards!',
    Only: 'Only Line&Whatsapp',
    This: 'This phase has ended',
    coins: ' coins',
    Hall: 'Hall Of Fame',
    Gold: 'Gold Medal Hall of Fame',
    Thet: 'The top 12 users who win the gold medal in the basketball game can be inducted into the Gold Medal Hall of Fame',
  },
  dailyTasks: {
    Roo: 'Room Announcement',
    Roo1: 'Room level',
    Tod: 'Today signed-in users (%s)',
    Con: 'Contributors',
    Roo2: 'Room diamonds',
    Roo3: 'Room task',
    Com: 'Complete both tasks to upgrade to the next level',
    Com4: 'Come and be the first to sign in!',
    Res: 'Reset Successful',
    Con5: 'Congratulations! Room upgraded to Level x',
    Gif: 'Gifting ranking 1-5',
    Gif6: 'Gifting ranking 6-10',
    EXP: 'EXP ranking',
    Adm: 'Admins number',
    Las: "Last Week's Data",
    Con7: 'Congratulations to xxx',
    roo: 'room upgraded to xxx',
    Roo8: 'Room level gifts',
    Nee: 'Need to reach a higher room level to unlock the gifts',
    Roo9: 'Room Contributors mainly display users who contributed to the room during the calculated period (month), including gifters, gift receivers, and EXP contributors.',
    The: 'The ranking displays the top ten contributors from highest to lowest contribution.',
    The10: 'The ranking is calculated on a monthly basis.',
    Mip: 'Miparty reserves the right of final interpretation of this event. Any illegal activity discovered will result in the deletion of all data and disqualification from the event.',
    Roo11: 'Room floating',
    Wel: 'Welcome to my Room',
    Rec: 'Receive the contributor reward quota',
    Top: 'Top gifters, room owner, Top EXP value',
    Top12: 'Top 1-5 gifters, room owner, Top EXP value',
    Top13: 'Top 1-10 gifters, room owner, Top EXP value',
    Top14: 'Top 1-15 gifters, room owner, Top EXP value',
    Con15: 'Congratulations on reaching the highest level',
    Thi: 'This room is really fun, come watch it with me',
    xxx: "@xxx's livestream~",
    Roo16: 'Room level rules',
    Wha: 'What is room level?',
    Eve: 'Everyone in a room can increase their room EXP values by completing daily tasks. When EXP values and diamond income reach a specified value, the room will be upgraded and receives a level reward (only available to hosts).',
    Roo17: 'Room Level',
    Bad: 'Badges',
    Dia: 'Diamonds required for upgrade',
    EXP18: 'EXP value required for upgrade',
    EXP19: 'EXP value required for upgrade',
    How: 'How to earn EXP values?',
    EXP20:
      'EXP values are earned by completing tasks together as a team. Some tasks can be completed multiple times to continuously earn EXP values. But there is a daily limit on the number of tasks you can complete.',
    Tod21: "Today's sign-in",
    Sen: 'Send general gift (1 time)',
    Sen22: 'Send lucky Gift (1 time)',
    Sen23: 'Send gifts (3 times) today',
    Tim: 'Time on mic today > 10 minutes',
    Win: 'Win 500 coins with room games today',
    Win24: 'Win 1000 coins with room games today',
    Sha: 'Share live room',
    Ext: 'Extra EXP value',
    You: "You can receive EXP values when your room's daily income reaches a certain level.",
    Dai: 'Daily income bonus',
    EXP25: 'EXP value bonus',
    Cum: 'Cumulative EXP values',
    Roo26: 'Room rewards are calculated and settled weekly.',
    Mip27:
      'Miparty reserves the right of final interpretation of this event. Any illegal activity discovered will result in the deletion of all data and disqualification from the event.',
    Dai28: 'Daily tasks',
    Roo29: 'Room privileges',
    Upg: 'Upgrade Tasks',
    Roo30: 'Room tasks',
    Roo31: 'Room Diamonds',
    Com32: 'Complete both tasks to upgrade to the next level',
    Dai33: 'Daily room tasks',
    Tod34: 'Today room cumulative EXP values',
    Tod35: 'Today personal cumulative EXP values',
    Bel: "Below is the completion status of your room's tasks today. You can invite friends to complete tasks.",
    Sen36: 'Send CP gifts',
    Sen37: 'Send Blind Box gifts',
    Tim38: 'Time on micToday',
    Roo39: 'Room game players today',
    Sha40: 'Share live room',
    Det: 'Detonate a Level 4 Bomb Today',
    Ext41: 'Extra rewards',
    Claim: 'Claim',
    Rec42: 'Received',
    Tod43: 'Today cumulative EXP values',
    Rules: 'Rules',
    Eac: 'Each level has different tasks.',
    Com44: 'Complete both tasks to upgrade to the next level.',
    Roo45: 'Room task rules',
    The46:
      'The task maximum value of each level is different. After completing a task, the EXP value will be automatically added to the room task EXP value total amount, and no need to claim manually.',
    Tas: 'Task maximum value for each level',
    Dai47: 'Daily task Maximum',
    Roo48: 'Room level',
    Ext49: 'Extra bonus rules',
    Whe: "When a room's daily income reaches a certain level, additional EXP values will be awarded. Only the room owner can claim this bonus.",
    Dai50: 'Daily income bonus',
    EXP51: 'EXP value bonus',
    Cum52: 'Cumulative EXP values',
    Dai53: 'Daily extra bonus tasks for the room will reset at 00:00 according to the agency time zone. Unclaimed EXP values will be reset to Zero.',
    Sig: 'Sign In',
    Com54: 'Completed',
    Got: 'Goto complete',
    Eac55: 'Each level has different task. Completing tasks can help your room level up.',
    Ify: "If you're a room contributor, you'll receive corresponding rewards when the host room upgrade.",
    Dai56: "Daily tasks will be reset at 00:00 in the room. Completed task EXP values will automatically accumulate towards the total room's EXP values.",
    Com57: 'Complete both tasks to upgrade to the next level.',
    Roo58: 'Room contributor rewards',
    Con59: 'Congratulations on successfully unlocking new level.',
    Con60: 'Congratulations on unlocking the highest level.',
    Roo61: 'Room owner',
    Top62: 'Top 1 gifter',
    Whe63: 'When a room is upgraded, the host and room contributors will receive additional rewards.',
    The64: 'The contributor quotas for each level are different.',
    Rew: 'Rewards earned by each user can be cumulated. For example, if a user is both the host owner and the top 1 gifter, he can get both rewards.',
    Con65: 'Contributors must contribute 1% or more of the total room income to receive coin rewards.',
    The66: "The room's level will automatically upgrade when completing the tasks of that level. For details, please check the rules page.",
    Onc: 'Once a level is upgraded, room contributors will receive the corresponding rewards, which will be sent immediately.',
    Spe: 'Special notice:',
    Con67:
      'Contributors must contribute 1% or more of the total room income of that level to receive rewards. If the requirements are not met, the rewards will be divided equally among other contributors.',
    Onl: 'Only the host owner and the top gifter will receive the corresponding coin rewards; other contributors will receive props rewards.',
    Level: 'Level',
    Rec68: 'Receive the contributor reward quota',
    Top69: 'Top gifters, room owner, Top EXP value',
    Use: 'Users may receive multiple rewards when they are both the host owner and a room contributor .',
    Mip70:
      'Miparty reserves the right of final interpretation of this event. Any illegal activity discovered will result in the deletion of all data and disqualification from the event.',
    Thi71: 'This event not available to IOS users.',
    Day: 'day',
    Roo72: 'Room rewards',
    Gif73: 'Sender',
    Tas74: 'EXP',
    Tasks: 'Tasks',
    EXP75: 'EXP values',
    Num: 'Number of users sending general gifts',
    Num76: 'Number of users sending lucky gifts',
    Num77: 'Number of users sending gifts≥ 3 times today',
    Num78: 'Number of users sharing rooms',
    Det79: 'Detonate a level 8 bomb today',
    Roo80: 'Room level badges',
    Roo81: 'Room admins number',
    Roo82: 'Room background',
    Roo83: 'Room level gifts',
    Roo84: 'Room cards',
    Roo85: 'Room chat bubbles',
    Unl: 'Unlock room emoji',
    Dis: 'Display badges in the room cover',
    Sen86: 'Send emoji in the comment section',
    Ent: 'Entry effects',
    Roo87: 'Room floating',
    Roo88: 'Room frame',
    GOm: 'GO my room',
    Con89: 'Contributors',
    Dai90: 'Daily tasks number',
    Ple: 'Please time on your mic in the room.',
  },
  discount: {
    Off: '50% Off Sale',
    Act: 'Activity time：9/30-10/9',
    New: 'New Gift',
    Ori: 'Original price：',
    Sal: 'Sale price:',
    Gen: 'General Gift',
    Mal: 'Mall Headwear/Ride',
    Days: '{0}Days',
    Got: 'Go to the mall',
    Des: 'Description',
    The: '1. The Settlement of host is based on the actual sellingprice of the Activity gifis.',
    Mip: '2. Miparty has the final right to interpret the activity',
    Thi: '3. This activity is not afflated with Apple.',
  },
  firstChargeRule: {
    Mon: 'Monthly first recharge rules',
    You: 'You can earn extra rewards for your monthly first recharge. Click the red area to check your rewards. For details, you can check the corresponding recharge amount.',
    coins: '{0}coins',
    Back: 'backpack gift',
    VIP: 'VIP',
    Frame: 'Frame',
    Ride: 'Ride',
    Cli: 'Click on the red area to recharge directly',
  },
  billExplanation: {
    Bil: 'Bill Description',
    Gif: 'Gifts: a summary of gifted coins',
    Rec: 'Recharge: Includes official recharge, official rewards, lucky gift rebates, coin reseller recharge, and event income.',
    Off: 'Official recharge',
    Off1: 'Official rewards',
    luc: 'lucky gift rebates',
    Coi: 'Coins reseller recharge',
    Eve: 'Event income',
    Gam: 'Games: Includes game inputs and outputs.',
    Oth: 'Other: Includes mall spending, VIP spending, and bullet comment spending.',
  },
  switchInstructions: {
    Swi: 'Switch Description',
    Tur: 'Turning special effects on/off also turns off the corresponding sound effects, but turning the sound effects on/off does not affect the special effects.',
    Tur1: 'Turning off a switch only affects the experience of audience himself and does not affect others in the room.',
    Ify: "If you don't want to receive messages about other users' lucky coin rebates, simply turn off the lucky gift notification switch.",
    Ify2: "If you don't want to receive messages/sound effects about other users receiving large gifts, simply turn off the special effects/sound effects for large gift notifications.",
    Ify3: "If you don't want to receive messages about other users receiving gifts, simply turn off the gift announcement switch.",
    Ify4: "If you don't want to receive messages/sound effects about other users entering a room, entering banner, or ride special effects, simply turn off the room entry information/entry sound effects switch.",
    Ify5: "If you don't want to receive other users' gift movement tracks and gift special effects, simply turn off the gift special effects switch.",
    Ify6: "If you don't want to receive coin rebate messages or game coin rebates notifications, simply turn off the game information switch.",
  },
  inviteNewUsers: {
    Inv: 'Invite friends to get rewards',
    Inv1: 'Inviter\n1.Ordinary users can invite new users and bind them. For each new user bound, they can earn corresponding invitation points\n2. Use the invitation points to participate in the Super Draw3. 3.When a new bound user recharges to the designated level, you can receive the corresponding gold coins or cash rewards\n*Remember to fill in your account information; otherwise, the rewards will not be issued\n4.The cash rewards will be distributed within 7 working days after the event ends\nNew user\n1.Binding with the inviter will grant you a binding gift package\n2. Earn rewards for completing daily tasks',
    Inv2: 'Inviter',
    Ord: '1.Ordinary users can invite new users and bind them. For each new user bound, they can earn corresponding invitation points',
    Use: '2. Use the invitation points to participate in the Super Draw.',
    Whe: '3.When a new bound user recharges to the designated level, you can receive the corresponding gold coins or cash rewards',
    Rem: '*Remember to fill in your account information; otherwise, the rewards will not be issued',
    The: '4.The cash rewards will be distributed within 7 working days after the event ends',
    New: 'New user',
    Bin: '1.Binding with the inviter will grant you a binding gift package',
    Ear: '2. Earn rewards for completing daily tasks',
    Ban: 'Bank Account',
    Inv3: 'Inviter',
    New4: 'New User',
    Rank: 'Rank',
    You: 'Your special invitation code is',
    Inv5: '*Invite new users to bind and get rewards! New bound users who recharge to the specified value can receive gold coins/cash rewards!',
    Cop: 'Copy link to share',
    Sup: 'Super Draw',
    Eac: 'Each bound user = {0} invitation points',
    Myi: 'My invitation points：',
    Draw: 'Draw*1',
    Draw6: 'Draw*5',
    Bin7: 'Binding of new users',
    Bin8: 'Binding new users recharge to the specified value you can get coins or cash rewards',
    You9: "*You can't get rewards without binding your bank information",
    Myr: 'My reward amount',
    Num: 'Number of binding',
    cli: 'click to see more',
    Con: 'Congratulations! You have successfully bound with a new user.',
    Ton: 'To not miss the rewards, remember to fill in your bank information!',
    You10: "You haven't bound your bank information yet. Fill in your bank information now! ",
    Ifn: '(If not completed before the end of the activity, the reward will not be issued)',
    Con11: 'Congratulations on getting the following rewards!',
    Kee: 'Keep drawing*{0}',
    Kee12: 'Keep drawing*{0}',
    The13: 'The current invitation points',
    The133: 'is not enough, go to invite more new users and bind, get invitation points!',
    You14: "You haven't bound a new user yet",
    Inv15:
      'Invited new users accumulatively recharge to the specified value, according to the highest level at the time of settlement can receive gold/cash rewards.When the event is settled, a single new user who has accumulated a recharge of $10 or more will receive a cash reward which will be transferred to your bank account. If less than $10 can be converted into gold coins, 50% of the gold coins will be distributed to your wallet (within 7 working days).',
    Inv16: 'Invite new users to accumulate recharges',
    Rew: 'Reward amount',
    Bin17: 'Binding users will receive binding rewards',
    Ent: 'Enter the invitation code',
    Rec: 'Recharge',
    Bin18: 'Bind Gift Pack',
    New19: 'New users can receive the following rewards after binding and the rewards will be automatically issued',
    Dai: 'Daily Sign in',
    Sta: 'Stay in the room for 10 mins',
    Fol: 'Follow 1 user',
    Rec20: 'Recharge any amount',
    New21: 'New user binding',
    Ent22: 'Enter the code',
    Onl: '*Only new users who have registered within 7 days can bind',
    Are: 'Are you sure to bind with this user?',
    No: 'No',
    Thi: 'This list is ranked based on the amount of rewards that users can receive after inviting new users to recharge',
    Inv23: 'Inviter：{0}\nAfter clicking the link to download and register, new users who bind will receive a binding gift package!\nInvitation code:{1}\nDownload：{2}',
    linkText1: 'Inviter：{0}',
    linkText2: 'After clicking the link to download and register, new users who bind will receive a binding gift package!',
    linkText3: 'Invitation code:{0}',
    linkText4: 'Download：{0}',
    Cop24: 'Copy successful! Share it now!',
    Not: 'Not filled in',
    The25: 'The user is not a new user, unable to bind',
    Bin26: 'Binding successful',
    Inv27: 'Invitation code error, binding failed',
    Confirm: 'Confirm',
    Go: 'Go',
    Later: 'Later',
    Rew41: 'Reward',
    Dai28: 'Daily tasks',
    Sign: 'Sign in',
    Youa: 'You are not in the region',
    Glob: 'Global',
    Midd: 'Middle East',
    Sout: 'South Asia',
    Sout2: 'Southeast Asia',
    Euro: 'Europe&America',
    Defa: 'Current region',
    Nod: 'No data',
    Bind: 'Binding date',
    This: 'This event has ended',
  },
  sevenDaysOfJoy: {
    Mip: 'Miparty\nDaily Challenge',
    Dai: 'Daily Challenge',
    Cel: 'Celebrity Gift Battle',
    Gam: 'Game King Challenge',
    Age: 'Agency Battle',
    Roo: 'Room Gift Challenge',
    Luc: 'Lucky Gifts Challenge',
    Onl: 'Online Recharge Challenge',
    Bil: 'Billionaire Battle',
    Joi: 'Join the {0} and win rich rewards',
    Act: 'Activity time：{0}00：00-23：59（GMT+3）',
    Mon: 'Monday',
    Tue: 'Tuesday',
    Wed: 'Wednesday',
    Thu: 'Thursday',
    Fri: 'Friday',
    Sat: 'Saturday',
    Sun: 'Sunday',
    Ong: 'Ongoing',
    Not: 'Not started',
    Ended: 'Ended',
    The: 'The ranking does not include gifts given to yourself.',
    The1: 'The rewards will be distributed within 3 working days',
    The2: 'The event starts on Monday (gmt+3)',
    Stay: 'Stay tuned',
    Cel3: 'Celebrity Gift',
    Bes: 'Best Sender',
    The4: 'The gift list of Celebrity Gift Battle will be ranked according to the number of gold coins given out.',
    The5: 'The best sender rank award for the celebrity gift battle is based on the number of gold coins given to celebrity gifts.',
    Bes6: 'Best Sender Rank Reward',
    Ran: 'Ranking based on the number of gold coins invested in the game on that day',
    Gma: 'Gmae Master Rank Reward',
    The7: 'The ranking is based on the total gold coin turnover of the agency on that day.',
    The8: 'The rewards will be distributed within 3 working days',
    Gol: 'Gold coin rewards are only given to the agent',
    not: 'not joined any agency yet',
    Age8: 'Agency Rank Reward',
    Age9: 'Agent&Top3 host',
    The10: 'The room is ranked based on the total number of gift coins received on that day.',
    Roo11: 'Room Rank Reward',
    The12: 'The ranking is based on the number of gold coins given out as lucky&m-lucky gifts on the same day',
    Ran13: 'Rank Reward',
    The14: 'The ranking is based on the gold coins recharged online on that day',
    Ran15: 'Ranking by gift coins given to the corresponding country on that day',
    Top: 'Top1 Country-Top1 User',
    Top16: 'Top2 Country-Top1 User',
    Top17: 'Top3 Country-Top1 User',
    Age18: 'Agency Income',
    Age19: 'Agency Ranking',
    Roo20: 'Room Income',
    Roo21: 'Room Ranking',
    Nat: 'National Gifting',
    Nat22: 'National Ranking',
  },
  jungleAdventure: {
    Mip: 'Miparty \nJungle Adventure',
    New: 'New User',
    Ord: 'Ordinary User',
    Com: 'Completing tasks will earn you keys and rich treasure chest rewards!Use the key to open the blind box!',
    The: 'The new user task time has ended. Hurry up and open the blind box! This page will no longer be displayed when the key is insufficient to open the blind box',
    Pha: 'Phase One',
    Pha1: 'Phase Two',
    Pha2: 'Phase Three',
    Pha3: 'Phase Four',
    Pha4: 'Phase Five',
    Ended: 'Ended',
    Rew: 'Reward Preview',
    Rew5: 'Reward Received',
    Con: 'Congratulations on completing this Phase and getting the following rewards, click Confirm to claim!',
    Sur: 'Surprise Blind Box',
    Open: 'Open*1',
    Open6: 'Open*5',
    My: 'My',
    Con7: 'Congratulations on opening the blind box and getting the following rewards!',
    Kee: 'Keep opening*1',
    Kee8: 'Keep opening*5',
    The9: 'The current 【】are not enough, go complete the tasks and collect it!',
    The10: 'The current',
    are: 'are not enough, go complete the tasks and collect it!',
    Bin: '1.Bind the mobile phone number',
    Com11: '2.Complete personal information',
    Sig: '3.Sign in at Miparty',
    The12: 'The avatar,nickname, gender, birthday and country information need to be improved',
    Bro: '1.Browse the wealth level activity page',
    Bro13: '2.Browse the first charge activity page',
    Bro14: '3. Browse the CP activity page',
    Cre: '1.Create a personal room',
    Tal: '2. Talk on mic in the Audio room for 10 minutes',
    Sta: '3. Stay in the Video room for 10 minutes(Not your own room)',
    Sen: '4. Send a message once on the public screen in the room',
    Fol: '5. Follow 3 hosts',
    Rec: '1.Recharge any amount',
    Sen15: '2. Send a barrage message in the room once',
    Par: '3. Participate in and invest in any one game',
    Sen16: '1.Send 1 general gift',
    Sen17: '2. Send 1 Lucky gift',
    Sen18: '3. Send 1 M-Lucky gift',
    Pur: '4. Purchase any goods in the mall',
    Bin19: '5. Bind the CP',
    CPc: 'CP can be bound by giving the first gift in the CP gift column: Rose Love Ring',
    Com20:
      '1.Completing daily tasks will earn you EXP and rewards. Each daily task has a limit of the number of times you can complete it each day. Once you have completed all the tasks, you will no longer be able to receive rewards on that day\n2. Completing weekly tasks will earn you EXP and rewards. Each weekly task can only be completed once a week. Once completed and rewarded, you will not receive any rewards in the same week\n3. Monthly treasure box rewards are accumulated based on the EXP obtained by users. After reaching the designated level, users can receive monthly treasure box rewards (the monthly treasure box statistics period is 4 natural weeks).\n4. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event\n5. The final interpretation right of this event belongs to the official. This event has nothing to do with Apple.Inc',
    Com21:
      '1.Completing daily tasks will earn you EXP and rewards. Each daily task has a limit of the number of times you can complete it each day. Once you have completed all the tasks, you will no longer be able to receive rewards on that day',
    Com22:
      '2. Completing weekly tasks will earn you EXP and rewards. Each weekly task can only be completed once a week. Once completed and rewarded, you will not receive any rewards in the same week',
    Mon: '3. Monthly treasure box rewards are accumulated based on the EXP obtained by users. After reaching the designated level, users can receive monthly treasure box rewards (the monthly treasure box statistics period is 4 natural weeks).',
    Ifa: '4. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event',
    The23: '5. The final interpretation right of this event belongs to the official. This event has nothing to do with Apple.Inc',
    MyExp: 'My Exp：',
    Ref: 'Refresh in：',
    mor: '{0}more can get the next level of reward',
    Dai: 'Daily tasks',
    You: 'You can get EXP by completing tasks, and you can get rich rewards by accumulating EXP.',
    Und: 'Undone',
    Com24: 'Come back tomorrow',
    Rec25: 'Receive',
    Tim: 'Time per day:',
    Wee: 'Weekly Tasks',
    Com26: 'Come back next week',
    Adv: 'Adventure Reward',
    Com27: 'Completing daily tasks will earn you the following rewards',
    Thi: 'This task currently available EXP:{0}',
    The28: 'The EXP currently obtained for this task: {0}',
    Mon29: 'Monthly Reward',
    Dai30: '1.Daily Sign in（Enter the page automatically sign in）',
    Sen31: "2.Send a message on the room's public screen",
    min: '3.10 minutes on mic in the same room',
    Sen32: '4.Send a gift',
    Rec33: '5.Recharge any amount',
    Sen34: '6.Send any one starlight gift',
    Fol35: '1.Follow each other with 3 users in the app',
    Com36: '2.Complete daily task ②18 times',
    Com37: '3.Complete daily task ④20 times',
    Inv: '4.Invest 50,000 coins in the game',
    Acc: '5.Accumulated recharge of 500k coins (including agent recharge)',
    Suc: 'Successfully received',
    Ple: 'Please complete the task first',
    Go: 'Go',
    Confirm: 'Confirm',
    Not: 'Not enough keys to open',
    When: 'When the wealth level reaches Lv.1, you can unlock the lucky gift.',
  },
  kingOfTheForest: {
    Kin: 'King Of The Forest',
    Tim: "Time:\n12/09-12/18\nRule:\n1.The ranking rewards will be sent to the winners' accounts within 3 working days after the event ends (Note: The ranking does not include gifts given to yourself.)\n2.During the event period, all users can earn points to upgrade tigers and claim upgrade rewards by sending event gifts\n3. Users can participate in hunting by consuming points. Hunting has a probability of success or failure. Those who succeed will receive random hunter rewards, while those who fail will receive random encouragement rewards\n4. Users can also obtain meat items and points by completing enhanced tasks. These items can increase the chances of winning the competition\n5. The official will place {60,000} gold coins into the prize pool every day. Users' competition points can be proportionally added to the prize pool. The 10 users who participate in the competition and win more times each day can participate in the division\n6. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event\n7. The final interpretation right of this activity belongs to the official. This activity has nothing to do with Apple.Inc",
    Hun: 'Hunting Ground',
    Dal: 'Daliy Hunting Price Pool',
    Rank: 'Rank',
    Tra: 'Training Ground',
    suc: 'success rate:{0}%',
    Lv: 'Lv.{0}',
    Nee: 'Need to cost {0} points to hunt 1 time',
    Hun1: 'Hunting Results',
    Rew: 'Reward',
    Sta: 'Start hunting*1\n{0}points',
    Sta2: 'Start hunting*10\n{0}points',
    Myp: 'My points：',
    Mys: 'My successful hunt:',
    Tor: 'To reach top 10 you still need to hunt:',
    Enh: 'Enhancement Task',
    Sen: 'Send {0} points activity gifts',
    Suc: 'Successfully hunted {0} times',
    Suc3: 'Successfully upgraded 1 tiger',
    Acc: 'Accumulated recharge {0} coins\n(Agent recharge is not included)',
    Hun4: 'Hunting Rules',
    Itc: "1. It costs {0} points to hunt once，{1} points to hunt 10times\n2. Complete the enhancement tasks to obtain meat items. Using meat can enhance the tiger's hunting ability\n3. A maximum of {2} meat can be used for each hunt\n4. Those who successfully hunt will receive hunter rewards, which are random. Those who fail to hunt will receive encouragement prizes, and the rewards are random",
    Tiger: 'Tiger',
    Res: 'Results',
    Suc5: 'Success',
    Lose: 'Lose',
    Not: 'Not enough points to participate in the hunt',
    You: 'Your Meat',
    Onl: 'Only a maximum of {0} meat can be used for each hunt',
    Cur: 'Current success rate:{0}%',
    The: 'The current highest success rate: {0}%',
    Hun6: 'Hunting Reward',
    Win: 'Winning may get you',
    Los: 'Losing may get you',
    Upg: 'Upgrade Reward Preview',
    Con: 'Congratulations on upgraded your tiger and received the following rewards!',
    Con7: 'Congratulations on your successful hunt and the following rewards!',
    Its: "It's a pity that you failed to hunt and received the following rewards!",
    Kee: 'Keep hunting*{0}',
    You8: 'You successfully hunt {0} times and fail {1} times in this hunt and receive the following rewards!',
    How: 'How to play?',
    The2: '1. The system provides {0} gold coins to the prize pool every day.\n2.Points consumed by participating in the hunt will be added to the prize pool in proportion.\n3. The top 10 users who successfully hunt more each day will participate in the division proportionally.',
    Bes: 'Best Hunter',
    Ref: 'Refresh',
    Tof: 'To finish',
    Fin: 'Finished',
    Poi: '{0}points',
    This: 'This event has ended',
    Dai: 'Daily Prize pool',
    You2: 'Your Nitrogen：',
    Confirm: 'Confirm',
    Can: 'Cancel',
    Rac5: 'Racing Results',
    General: 'General gifts: 1coins = 1 points, lucky gifts：10 coins =1 points',
    Not2: 'Not enough meat',
  },
  christmas2025: {
    Mer: 'Merry Christmas',
    Tim: "Time\n12/23-12/30\n\nRule\n1.The ranking rewards will be sent to the winners' accounts within 3 working days after the event ends\n2. By giving event gifts, you can obtain candy points to unlock the Christmas party scene (regular gift: 1 gold coin =1 candy, lucky gift: 10 gold coins =1 candy). Unlock it to get rich rewards (* Note: Does not include giving gifts to yourself)\n3. Use candy points to participate in find Santa Claus to flip cards and collect Santa Claus. The top 3 users who collect more Santa Santas every day can receive daily rank rewards\n4. By obtaining bells in find Santa Claus , you can send Christmas greetings on the Blessing Wall\n5. If a user is suspected of using illegal methods to boost data during the event period, the official reserves the right to clear the event data and disqualify the user from the event\n6. The final interpretation right of this event belongs to the official. This event has nothing to do with Apple.Inc",
    Ble: 'Blessing Wall',
    You: 'You can send a blessing for free once. To send another one, you need to collect bells in "Find Santa Claus"',
    My: 'My {0}',
    Send: 'Send*1',
    Send1: 'Send',
    You2: 'Your content contains sensitive words, please check and modify',
    The: "There aren't enough bells at the moment. Hurry up and find Santa Claus to collect them!",
    Chr: 'Christmas Party',
    Chr3: 'Christmas Market',
    Dec: 'Decoration',
    Chr4: 'Christmas Dinner',
    Mov: 'Movie Night',
    Chr5: 'Christmas Presents',
    Sen: 'Send gifts collect candy canes to unlock the Christmas scene can get rich rewards!',
    Dai: 'Daily Task',
    Dai6: 'Daily sign in',
    Sen7: 'Send {0} blessings',
    Sen8: 'Send {0} points activity gift',
    Fin: 'Find Santa Claus {0} times',
    Acc: 'Accumulated recharge {0} coins \n（Agent recharge is not included）',
    Sig: 'Sign in',
    Sig9: 'Signed in',
    Fin10: 'Find Santa Claus',
    Joi: 'Join in Santa flip to get the bells and rich rewards!',
    His: 'History',
    Card: 'Card',
    Rew: 'Reward',
    Date: 'Date',
    Not: 'Not enough candy cane . Send activity gifts and collect some!',
    Dai11: 'Daily Rank',
    Thi: 'This list of ranking according to find the number of Santa Claus',
    San: 'Santa Claus Reward',
    Chr12: 'Christmas Elk Reward',
    Con: 'Congratulations on successfully flipping Santa Claus and receiving the following rewards！',
    Sor: "Sorry, you're flipping elk cards and getting the following rewards",
    Kee: 'Keep flipping*1',
    Kee13: 'Keep flipping*10',
    Res: 'Result',
    Bell: 'Bell',
    Ref: 'Refresh:',
    Tof: 'To finish',
  },
};
